package com.anjuros.website.components.language

import androidx.compose.runtime.Composable
import androidx.compose.runtime.compositionLocalOf
import com.anjuros.website.templates.selection.util.Res

enum class Language(val code: String, val nativeName: String, val flag: String) {
    EN("en", "English", flag = Res.Image.flag_uk)
}

interface ResKeyType {
    val keyName: String
}

enum class ResKey : ResKeyType {
    NAV_TRADES,
    NAV_BUILDER,
    NAV_TEMPLATES,
    NAV_TEMPLATES_SUBTITLE,
    NAV_PORTAL_SUBITEM,
    NAV_SEO_SERVICES_SUBITEM,
    NAV_HOME,
    NAV_PRICES,
    NAV_BLOG,
    NAV_CONTACT,
    NAV_ABOUT,
    NAV_FAQ,
    BUILDER_PAGE_TITLE,
    BUILDER_PAGE_SUBTITLE,
    BUILDER_INFO1_TITLE,
    BUILDER_INFO1_SUBTITLE,
    BUILDER_INFO1_POINT1,
    BUILDER_INFO1_POINT2,
    BUILDER_INFO1_POINT3,
    BUILDER_INFO1_POINT4,
    BUILDER_INFO1_POINT5,
    BUILDER_INFO1_POINT6,
    BUILDER_INFO2_TITLE,
    BUILDER_INFO2_SUBTITLE,
    BUILDER_INFO2_POINT1,
    BUILDER_INFO2_POINT2,
    BUILDER_INFO2_POINT3,
    BUILDER_INFO2_POINT4,
    BUILDER_INFO2_POINT5,
    BUILDER_INFO3_TITLE,
    BUILDER_INFO3_SUBTITLE,
    BUILDER_INFO3_POINT1,
    BUILDER_INFO3_POINT2,
    BUILDER_INFO3_POINT3,
    BUILDER_INFO3_POINT4,
    BUILDER_INFO3_POINT5,
    BUILDER_INFO4_TITLE,
    BUILDER_INFO4_SUBTITLE,
    BUILDER_INFO4_POINT1,
    BUILDER_INFO4_POINT2,
    BUILDER_INFO4_POINT3,
    BUILDER_INFO4_POINT4,
    BUILDER_INFO4_POINT5,
    BUILDER_INFO5_TITLE,
    BUILDER_INFO5_POINT1,
    BUILDER_INFO5_POINT2,
    BUILDER_INFO5_POINT3,
    BUILDER_INFO5_POINT4,
    BUILDER_INFO5_POINT5,
    BUILDER_FINAL_TITLE,
    BUILDER_FINAL_SUBTITLE,
    BUILDER_PREVIEW_OPTIONS,
    BUILDER_PREVIEW_TOOLTIP_DRAG,
    BUILDER_PREVIEW_TOOLTIP_CONTENT,
    BUILDER_PREVIEW_TOOLTIP_PLACEHOLDER,
    BUILDER_CURRENT_SELECTION,
    PLACEHOLDER_SERVICE_TEXT,
    PLACEHOLDER_SERVICE_TITLE,
    PLACEHOLDER_VALUES,
    PLACEHOLDER_SECONDARY_BUTTON,
    PLACEHOLDER_ABOUT_TITLE,
    PLACEHOLDER_ABOUT_LONGER_TEXT,
    PLACEHOLDER_ABOUT_LONGER_TEXT2,
    PLACEHOLDER_ABOUT_TEXT,
    PLACEHOLDER_REVIEWS_TITLE,
    PLACEHOLDER_QUESTION,
    PLACEHOLDER_ANSWER,
    PLACEHOLDER_SLOGAN,
    PLACEHOLDER_REVIEW_TITLE,
    PLACEHOLDER_REVIEW_DESC,
    PLACEHOLDER_REVIEW_NAME,
    PLACEHOLDER_COMPANY_NAME,
    PLACEHOLDER_SERVICE_PRICE,
    PLACEHOLDER_SERVICE_TIME,
    PLACEHOLDER_PRODUCT_TYPE,
    PLACEHOLDER_PRODUCT_TITLE,
    PLACEHOLDER_PRODUCTS_MAIN_TITLE,
    PLACEHOLDER_PRODUCT_DESC,
    PLACEHOLDER_PRODUCT_PRICE,
    PLACEHOLDER_PROJECT_DESC,
    PLACEHOLDER_PROJECT_TITLE,
    PLACEHOLDER_ACHIEVEMENT,
    PLACEHOLDER_EXPERIENCE,
    PLACEHOLDER_TIMETABLE,
    PLACEHOLDER_OPTION,
    PLACEHOLDER_CONTACT_PLACEHOLDER,
    PLACEHOLDER_CONTACT_LABEL,
    PLACEHOLDER_EMPTY,
    FAQ1_Q,
    FAQ1_A,
    FAQ2_Q,
    FAQ2_A,
    FAQ3_Q,
    FAQ3_A,
    FAQ4_Q,
    FAQ4_A,
    FAQ5_Q,
    FAQ5_A,
    FAQ6_Q,
    FAQ6_A,
    FAQ7_Q,
    FAQ7_A,
    FAQ8_Q,
    FAQ8_A,
    FAQ9_Q,
    FAQ9_A,
    FAQ10_Q,
    FAQ10_A,
    FAQ11_Q,
    FAQ11_A,
    FAQ12_Q,
    FAQ12_A,
    FAQ13_Q,
    FAQ13_A,
    FAQ14_Q,
    FAQ14_A,
    FAQ15_Q,
    FAQ15_A,
    SEE_ALL_TEMPLATES,
    MIX_CONTENT_TEXT,
    MIX_PLACEHOLDER_TEXT,
    TEMPLATE_NEXTSTEP2_BUTTON_TEXT,
    TEMPLATE_NEXTSTEP2_BUTTON2_TEXT,
    WORK_WITH_ELECTRICIAN_TITLE,
    WORK_WITH_HANDYMAN_TITLE,
    WORK_WITH_PAINTER_TITLE,
    WORK_WITH_HAIDRESSER_TITLE,
    WORK_WITH_DOGWALKER_TITLE,
    WORK_WITH_BAKER_TITLE,
    WORK_WITH_INSTRUCTOR_TITLE,
    WORK_WITH_PUB_TITLE,
    PRIVACY_POLICY_SEE,
    PRIVACY_POLICY_TITLE,
    PRIVACY_POLICY_LAST_UPDATED,
    PRIVACY_POLICY_SECTION1_TITLE,
    PRIVACY_POLICY_SECTION1_TEXT1,
    PRIVACY_POLICY_SECTION1_TEXT2,
    PRIVACY_POLICY_SECTION2_TITLE,
    PRIVACY_POLICY_SECTION2_BUSINESS,
    PRIVACY_POLICY_SECTION2_EMAIL,
    PRIVACY_POLICY_SECTION3_TITLE,
    PRIVACY_POLICY_SECTION3A_TITLE,
    PRIVACY_POLICY_SECTION3A_TEXT1,
    PRIVACY_POLICY_SECTION3A_TEXT2,
    PRIVACY_POLICY_SECTION3B_TITLE,
    PRIVACY_POLICY_SECTION3B_TEXT1,
    PRIVACY_POLICY_SECTION3B_TEXT2,
    PRIVACY_POLICY_SECTION4_TITLE,
    PRIVACY_POLICY_SECTION4_TEXT1,
    PRIVACY_POLICY_SECTION5_TITLE,
    PRIVACY_POLICY_SECTION5_TEXT1,
    PRIVACY_POLICY_SECTION6_TITLE,
    PRIVACY_POLICY_SECTION6_TEXT1,
    PRIVACY_POLICY_SECTION7_TITLE,
    PRIVACY_POLICY_SECTION7_TEXT1,
    PRIVACY_POLICY_SECTION8_TITLE,
    PRIVACY_POLICY_SECTION8_TEXT1,
    PRIVACY_POLICY_SECTION9_TITLE,
    PRIVACY_POLICY_SECTION9_TEXT1,
    TEMPLATE1,
    TEMPLATE1_SUBTITLE,
    TEMPLATE1_HEADER,
    TEMPLATE1_SUBHEADER,
    TEMPLATE2,
    TEMPLATE2_SUBTITLE,
    TEMPLATE2_HEADER,
    TEMPLATE2_SUBHEADER,
    TEMPLATE4,
    TEMPLATE4_SUBTITLE,
    TEMPLATE4_HEADER,
    TEMPLATE4_SUBHEADER,
    TEMPLATE5,
    TEMPLATE5_SUBTITLE,
    TEMPLATE5_HEADER,
    TEMPLATE5_SUBHEADER,
    TEMPLATE6,
    TEMPLATE6_SUBTITLE,
    TEMPLATE6_HEADER,
    TEMPLATE6_SUBHEADER,
    TEMPLATE8,
    TEMPLATE9,
    TEMPLATE9_SUBTITLE,
    TEMPLATE9_HEADER,
    TEMPLATE9_SUBHEADER,
    TEMPLATE10,
    TEMPLATE10_SUBTITLE,
    TEMPLATE10_HEADER,
    TEMPLATE10_SUBHEADER,
    TEMPLATE8_SUBTITLE,
    TEMPLATE8_HEADER,
    TEMPLATE8_SUBHEADER,
    TEMPLATE8_HEADER_SUBPAGE1,
    TEMPLATE8_SUBHEADER_SUBPAGE1,
    TEMPLATE8_HEADER_SUBPAGE2,
    TEMPLATE8_SUBHEADER_SUBPAGE2,
    TEMPLATE8_HEADER_SUBPAGE3,
    TEMPLATE8_SUBHEADER_SUBPAGE3,
    TEMPLATE_MIX,
    TEMPLATE_MIX_SUBTITLE,
    CONTACT_NAME_LABEL,
    CONTACT_NAME,
    CONTACT_EMAIL_LABEL,
    CONTACT_EMAIL,
    CONTACT_MESSAGE_LABEL,
    CONTACT_MESSAGE,
    CONTACT_NOTE_LABEL,
    CONTACT_NOTE,
    CONTACT_DATE_LABEL,
    CONTACT_DATE,
    BUTTON_CONTACT_SUBMIT,
    BUTTON_CONTACT_SUBMIT_DEMO,
    CONTACT_REFERRAL_CODE_LABEL,
    CONTACT_REFERRAL_CODE,
    CONTACT_PHONE_LABEL,
    CONTACT_PHONE,
    CONTACT_VALIDATION_SPAM,
    SPAM_PROTECTION_INFO_TITLE,
    SPAM_PROTECTION_INFO_SUBTITLE,
    SPAM_PROTECTION_INFO_LEARN_MORE,
    TEMPLATE_MIX_HEADER_TITLE,
    TEMPLATE_MIX_HEADER,
    TEMPLATE_MIX_SERVICES_TITLE,
    TEMPLATE_MIX_SERVICE,
    TEMPLATE_MIX_PRICES_TIMETABLES,
    TEMPLATE_MIX_PRICES,
    TEMPLATE_MIX_TIMETABLES,
    TEMPLATE_MIX_REVIEWS,
    TEMPLATE_MIX_FAQ,
    TEMPLATE_MIX_CONTACT_TITLE,
    TEMPLATE_MIX_CONTACT_FORM,
    TEMPLATE_MIX_CONTACT_FORMS_TITLE,
    TEMPLATE_MIX_CONTACT,
    TEMPLATE_MIX_ABOUT_ME,
    TEMPLATE_MIX_FOOTERS,
    TEMPLATE_MIX_FOOTER,
    TEMPLATE_MIX_CATEGORIES,
    TEMPLATE_MIX_YOUR_SELECTION,
    TEMPLATE_MIX_CLEAR_ALL,
    TEMPLATE_MIX_GET_THE_WEBSITE,
    TEMPLATE_MIX_CHECK_THE_WEBSITE,
    TEMPLATE_MIX_PREVIEW_THE_WEBSITE,
    TEMPLATE_MIX_CHOOSE_THIS_SELECTION,
    TEMPLATE_MIX_CONTACT_FORM_TITLE,
    TEMPLATE_MIX_CONTACT_FORM_TITLE_SUCCESS,
    TEMPLATE_MIX_CONTACT_FORM_TITLE_SUCCESS_DEMO,
    TEMPLATE_MIX_CONTACT_FORM_MSG,
    TEMPLATE_MIX_SELECTION_INFO,
    TEMPLATE_MIX_SELECTION_INFO_SUBTITLE,
    TEMPLATE_MIX_SELECTION_INFO_EMPTY,
    TEMPLATE_MIX_SELECTION_INFO_SUBTITLE_EMPTY,
    TEMPLATE_MIX_SELECTION_MESSAGE_EMPTY,
    TEMPLATE_MIX_SELECTION_INFO_SUBTITLE_EMPTY_MOBILE,
    TEMPLATE_MIX_SELECTION_MESSAGE_EMPTY_MOBILE,
    CONTACT_FORM_REQUIRED,
    CONTACT_FORM_EMAIL_VALID,
    CONTACT_FORM_PHONE_VALID,
    TEXT_CONTACT_FORM_ERROR,
    CONTACT_FORM_SENDING,
    TEMPLATE_MIX_SECTION10,
    TEMPLATE_MIX_SECTION11,
    TEMPLATE_MIX_HEADER_SUMMARY_SUBTITLE,
    TEMPLATE_MIX_ABOUTME_SUMMARY_SUBTITLE,
    TEMPLATE_MIX_SERVICES_SUMMARY_SUBTITLE,
    TEMPLATE_MIX_PRICES_SUMMARY_SUBTITLE,
    TEMPLATE_MIX_TIMETABLE_SUMMARY_SUBTITLE,
    TEMPLATE_MIX_REVIEWS_SUMMARY_SUBTITLE,
    TEMPLATE_MIX_FAQ_SUMMARY_SUBTITLE,
    TEMPLATE_MIX_CONTACT_SUMMARY_SUBTITLE,
    TEMPLATE_MIX_CONTACT_FORM_SUMMARY_SUBTITLE,
    TEMPLATE_MIX_FOOTER_SUMMARY_SUBTITLE,
    TEMPLATE_MIX_NAV_STEP1,
    TEMPLATE_MIX_NAV_STEP2,
    TEMPLATE_MIX_NAV_STEP3,
    TEMPLATE_MIX_NAV_STEP4,
    TEMPLATE_MIX_NAV_STEP4_SHORT,
    CONTACT_FORM_URGENCY_LABEL,
    CONTACT_FORM_AREA_LABEL,
    CONTACT_FORM_WHAT_WORK_LABEL,
    //SEO
    //==========BLOG============
    BLOG1_TITLE,
    BLOG1_SECTION1_TITLE,
    BLOG1_SECTION1_PARAGRAPH1,
    BLOG1_SECTION1_PARAGRAPH2,
    BLOG1_SECTION1_PARAGRAPH3,
    BLOG1_SECTION1_PARAGRAPH4,
    BLOG1_SECTION2_TITLE,
    BLOG1_SECTION2_PARAGRAPH1,
    BLOG1_SECTION2_PARAGRAPH2,
    BLOG1_SECTION2_PARAGRAPH3,
    BLOG1_SECTION2_PARAGRAPH4,
    BLOG1_SECTION2_LIST1,
    BLOG1_SECTION2_LIST2,
    BLOG1_SECTION2_LIST3,
    BLOG1_SECTION2_LIST4,
    BLOG1_SECTION3_TITLE,
    BLOG1_SECTION3_PARAGRAPH1,
    BLOG1_SECTION3_PARAGRAPH2,
    BLOG1_SECTION3_PARAGRAPH3,
    BLOG1_SECTION3_PARAGRAPH4,
    BLOG1_SECTION3_PARAGRAPH5,
    BLOG1_SECTION3_LIST1,
    BLOG1_SECTION3_LIST2,
    BLOG1_SECTION3_LIST3,
    BLOG1_SECTION3_LIST4,
    BLOG1_SECTION4_TITLE,
    BLOG1_SECTION4_PARAGRAPH1,
    BLOG1_SECTION4_PARAGRAPH2,
    BLOG1_SECTION4_PARAGRAPH3,
    BLOG1_SECTION4_PARAGRAPH4,
    BLOG1_SECTION4_LIST1,
    BLOG1_SECTION4_LIST2,
    BLOG1_SECTION4_LIST3,
    BLOG1_SECTION4_LIST4,
    BLOG1_SECTION5_TITLE,
    BLOG1_SECTION5_PARAGRAPH1,
    BLOG1_SECTION5_PARAGRAPH2,
    BLOG1_SECTION5_PARAGRAPH3,
    BLOG1_SECTION5_PARAGRAPH4,
    BLOG1_SECTION5_LIST1,
    BLOG1_SECTION5_LIST2,
    BLOG1_SECTION5_LIST3,
    BLOG1_SECTION5_LIST4,
    BLOG1_SECTION5_LIST5,
    BLOG1_SECTION6_TITLE,
    BLOG1_SECTION6_PARAGRAPH1,
    BLOG1_SECTION6_PARAGRAPH2,
    BLOG1_SECTION6_PARAGRAPH3,
    BLOG1_SECTION6_PARAGRAPH4,
    BLOG1_SECTION7_TITLE,
    BLOG1_SECTION7_PARAGRAPH1,
    BLOG1_SECTION7_PARAGRAPH2,
    BLOG1_SECTION7_PARAGRAPH3,
    BLOG1_SECTION7_PARAGRAPH4,
    BLOG1_SECTION7_PARAGRAPH5,
    BLOG1_SECTION7_LIST1,
    BLOG1_SECTION7_LIST2,
    BLOG1_SECTION7_LIST3,
    BLOG1_SECTION7_LIST4,
    BLOG1_SECTION7_LIST5,
    BLOG1_SECTION7_LIST6,
    BLOG1_SECTION7_LIST7,
    BLOG1_SECTION7_LIST8,
    BLOG1_SECTION8_TITLE,
    BLOG1_SECTION8_PARAGRAPH1,
    BLOG1_SECTION8_PARAGRAPH2,
    BLOG1_SECTION8_PARAGRAPH3,
    BLOG1_SECTION8_PARAGRAPH4,
    BLOG1_SECTION8_PARAGRAPH5,
    BLOG1_SECTION8_LIST1,
    BLOG1_SECTION8_LIST2,
    BLOG1_SECTION8_LIST3,
    BLOG1_SECTION8_LIST4,
    BLOG1_SECTION8_LIST5,
    BLOG1_SECTION9_TITLE,
    BLOG1_SECTION9_PARAGRAPH1,
    BLOG1_SECTION9_PARAGRAPH2,
    BLOG1_SECTION9_PARAGRAPH3,
    BLOG1_SECTION10_TITLE,
    BLOG1_SECTION10_PARAGRAPH1,
    BLOG1_SECTION10_PARAGRAPH2,
    BLOG1_SECTION10_PARAGRAPH3,
    BLOG1_SECTION10_LIST1,
    BLOG1_SECTION10_LIST2,
    BLOG1_SECTION10_LIST3,
    BLOG1_SECTION10_LIST4,
    BLOG1_SECTION10_LIST5,
    BLOG1_SECTION10_LIST6,
    BLOG1_SECTION11_TITLE,
    BLOG1_SECTION11_SUBTITLE1,
    BLOG1_SECTION11_SUBTITLE2,
    BLOG1_SECTION11_SUBTITLE3,
    BLOG1_SECTION11_PARAGRAPH1,
    BLOG1_SECTION11_PARAGRAPH2,
    BLOG1_SECTION11_PARAGRAPH3,
    BLOG1_SECTION12_TITLE,
    BLOG1_SECTION12_TABLE_HEADER1,
    BLOG1_SECTION12_TABLE_HEADER2,
    BLOG1_SECTION12_ROW1_COL1,
    BLOG1_SECTION12_ROW1_COL2,
    BLOG1_SECTION12_ROW2_COL1,
    BLOG1_SECTION12_ROW2_COL2,
    BLOG1_SECTION12_ROW3_COL1,
    BLOG1_SECTION12_ROW3_COL2,
    BLOG1_SECTION12_ROW4_COL1,
    BLOG1_SECTION12_ROW4_COL2,
    BLOG1_SECTION12_ROW5_COL1,
    BLOG1_SECTION12_ROW5_COL2,
    BLOG1_SECTION13_TITLE,
    BLOG1_SECTION13_PARAGRAPH1,
    BLOG1_SECTION14_TITLE,
    BLOG1_SECTION14_PARAGRAPH1,
    BLOG1_SECTION14_PARAGRAPH2,
    BLOG1_SECTION14_PARAGRAPH3,
    BLOG1_SECTION14_PARAGRAPH4,
    BLOG1_SECTION14_PARAGRAPH5,
    //BLOG2
    BLOG2_TITLE,
    BLOG2_DISPLAY_TITLE,
    BLOG2_SECTION1_TITLE,
    BLOG2_SECTION1_PARAGRAPH1,
    BLOG2_SECTION1_PARAGRAPH2,
    BLOG2_SECTION1_PARAGRAPH3,
    BLOG2_SECTION2_TITLE,
    BLOG2_SECTION2_PARAGRAPH1,
    BLOG2_SECTION2_PARAGRAPH2,
    BLOG2_SECTION2_PARAGRAPH3,
    BLOG2_SECTION3_TITLE,
    BLOG2_SECTION3_PARAGRAPH1,
    BLOG2_SECTION3_PARAGRAPH2,
    BLOG2_SECTION3_PARAGRAPH3,
    BLOG2_SECTION4_TITLE,
    BLOG2_SECTION4_PARAGRAPH1,
    BLOG2_SECTION4_PARAGRAPH2,
    BLOG2_SECTION4_PARAGRAPH3,
    BLOG2_SECTION4_PARAGRAPH4,
    BLOG2_SECTION5_TITLE,
    BLOG2_SECTION5_PARAGRAPH1,
    BLOG2_SECTION5_PARAGRAPH2,
    BLOG2_SECTION5_PARAGRAPH3,
    BLOG2_SECTION6_TITLE,
    BLOG2_SECTION6_PARAGRAPH1,
    BLOG2_SECTION6_PARAGRAPH2,
    BLOG2_SECTION6_PARAGRAPH3,
    BLOG2_SECTION6_PARAGRAPH4,
    BLOG2_SECTION7_TITLE,
    BLOG2_SECTION7_PARAGRAPH1,
    BLOG2_SECTION7_PARAGRAPH2,
    BLOG2_SECTION7_PARAGRAPH3,
    BLOG2_SECTION7_PARAGRAPH4,
    BLOG2_SECTION8_TITLE,
    BLOG2_SECTION8_PARAGRAPH1,
    BLOG2_SECTION8_PARAGRAPH2,
    BLOG2_SECTION8_PARAGRAPH3,
    BLOG2_SECTION8_PARAGRAPH4,
    BLOG2_SECTION9_TITLE,
    BLOG2_SECTION9_PARAGRAPH1,
    BLOG2_SECTION9_PARAGRAPH2,
    BLOG2_SECTION9_PARAGRAPH3,
    BLOG2_SECTION10_TITLE,
    BLOG2_SECTION10_PARAGRAPH1,
    BLOG2_SECTION10_PARAGRAPH2,
    BLOG2_SECTION10_PARAGRAPH3,
    BLOG2_SECTION11_TITLE,
    BLOG2_SECTION11_PARAGRAPH1,
    BLOG2_SECTION11_PARAGRAPH2,
    BLOG2_SECTION11_PARAGRAPH3,
    BLOG2_SECTION11_PARAGRAPH4,
    BLOG2_SECTION12_TITLE,
    BLOG2_SECTION12_PARAGRAPH1,
    BLOG2_SECTION12_TABLE_HEADER1,
    BLOG2_SECTION12_TABLE_HEADER2,
    BLOG2_SECTION12_ROW1_COL1,
    BLOG2_SECTION12_ROW1_COL2,
    BLOG2_SECTION12_ROW2_COL1,
    BLOG2_SECTION12_ROW2_COL2,
    BLOG2_SECTION12_ROW3_COL1,
    BLOG2_SECTION12_ROW3_COL2,
    BLOG2_SECTION12_ROW4_COL1,
    BLOG2_SECTION12_ROW4_COL2,
    BLOG2_SECTION12_ROW5_COL1,
    BLOG2_SECTION12_ROW5_COL2,
    BLOG2_SECTION13_TITLE,
    BLOG2_SECTION13_PARAGRAPH1,
    BLOG2_SECTION13_TABLE_HEADER1,
    BLOG2_SECTION13_TABLE_HEADER2,
    BLOG2_SECTION13_TABLE_HEADER3,
    BLOG2_SECTION13_TABLE_HEADER4,
    BLOG2_SECTION13_ROW1_COL1,
    BLOG2_SECTION13_ROW1_COL2,
    BLOG2_SECTION13_ROW1_COL3,
    BLOG2_SECTION13_ROW1_COL4,
    BLOG2_SECTION13_ROW2_COL1,
    BLOG2_SECTION13_ROW2_COL2,
    BLOG2_SECTION13_ROW2_COL3,
    BLOG2_SECTION13_ROW2_COL4,
    BLOG2_SECTION13_ROW3_COL1,
    BLOG2_SECTION13_ROW3_COL2,
    BLOG2_SECTION13_ROW3_COL3,
    BLOG2_SECTION13_ROW3_COL4,
    BLOG2_SECTION13_ROW4_COL1,
    BLOG2_SECTION13_ROW4_COL2,
    BLOG2_SECTION13_ROW4_COL3,
    BLOG2_SECTION13_ROW4_COL4,
    BLOG2_SECTION13_ROW5_COL1,
    BLOG2_SECTION13_ROW5_COL2,
    BLOG2_SECTION13_ROW5_COL3,
    BLOG2_SECTION13_ROW5_COL4,
    BLOG2_SECTION13_PARAGRAPH2,
    BLOG2_SECTION15_TITLE,
    BLOG2_SECTION15_PARAGRAPH1,
    BLOG2_SECTION15_LIST1,
    BLOG2_SECTION15_LIST2,
    BLOG2_SECTION15_LIST3,
    BLOG2_SECTION15_LIST4,
    BLOG2_SECTION15_LIST5,
    BLOG2_SECTION15_LIST6,
    BLOG2_SECTION15_LIST7,
    BLOG2_SECTION15_LIST8,
    BLOG2_SECTION15_PARAGRAPH2,
    BLOG2_SECTION16_TITLE,
    BLOG2_SECTION16_PARAGRAPH1,
    BLOG2_SECTION16_PARAGRAPH2,
    BLOG2_SECTION16_PARAGRAPH3,
    BLOG2_SECTION17_TITLE,
    BLOG2_SECTION17_SUBTITLE1,
    BLOG2_SECTION17_PARAGRAPH1,
    BLOG2_SECTION17_SUBTITLE2,
    BLOG2_SECTION17_PARAGRAPH2,
    BLOG2_SECTION17_SUBTITLE3,
    BLOG2_SECTION17_PARAGRAPH3,
    BLOG2_SECTION17_SUBTITLE4,
    BLOG2_SECTION17_PARAGRAPH4,
    BLOG2_SECTION17_SUBTITLE5,
    BLOG2_SECTION17_PARAGRAPH5,
    //====BLOG3
    BLOG3_TITLE,
    BLOG3_DISPLAY_TITLE,
    BLOG3_SECTION1_TITLE,
    BLOG3_SECTION1_PARAGRAPH1,
    BLOG3_SECTION1_PARAGRAPH2,
    BLOG3_SECTION1_PARAGRAPH3,
    BLOG3_SECTION2_TITLE,
    BLOG3_SECTION2_PARAGRAPH1,
    BLOG3_SECTION2_PARAGRAPH2,
    BLOG3_SECTION3_TITLE,
    BLOG3_SECTION3_PARAGRAPH1,
    BLOG3_SECTION3_PARAGRAPH2,
    BLOG3_SECTION4_TITLE,
    BLOG3_SECTION4_PARAGRAPH1,
    BLOG3_SECTION4_PARAGRAPH2,
    BLOG3_SECTION5_TITLE,
    BLOG3_SECTION5_PARAGRAPH1,
    BLOG3_SECTION5_PARAGRAPH2,
    BLOG3_SECTION6_TITLE,
    BLOG3_SECTION6_PARAGRAPH1,
    BLOG3_SECTION6_PARAGRAPH2,
    BLOG3_SECTION7_TITLE,
    BLOG3_SECTION7_PARAGRAPH1,
    BLOG3_SECTION7_PARAGRAPH2,
    BLOG3_SECTION8_TITLE,
    BLOG3_SECTION8_PARAGRAPH1,
    BLOG3_SECTION8_PARAGRAPH2,
    BLOG3_SECTION9_TITLE,
    BLOG3_SECTION9_PARAGRAPH1,
    BLOG3_SECTION9_PARAGRAPH2,
    BLOG3_SECTION10_TITLE,
    BLOG3_SECTION10_PARAGRAPH1,
    BLOG3_SECTION10_PARAGRAPH2,
    BLOG3_SECTION10_PARAGRAPH3,
    BLOG3_SECTION11_TITLE,
    BLOG3_SECTION11_PARAGRAPH1,
    BLOG3_SECTION11_PARAGRAPH2,
    BLOG3_SECTION11_PARAGRAPH3,
    BLOG3_SECTION11_TABLE_HEADER1,
    BLOG3_SECTION11_TABLE_HEADER2,
    BLOG3_SECTION11_ROW1_COL1,
    BLOG3_SECTION11_ROW1_COL2,
    BLOG3_SECTION11_ROW2_COL1,
    BLOG3_SECTION11_ROW2_COL2,
    BLOG3_SECTION11_ROW3_COL1,
    BLOG3_SECTION11_ROW3_COL2,
    BLOG3_SECTION11_ROW4_COL1,
    BLOG3_SECTION11_ROW4_COL2,
    BLOG3_SECTION11_ROW5_COL1,
    BLOG3_SECTION11_ROW5_COL2,
    BLOG3_SECTION11_ROW6_COL1,
    BLOG3_SECTION11_ROW6_COL2,
    BLOG3_SECTION12_TITLE,
    BLOG3_SECTION12_PARAGRAPH1,
    BLOG3_SECTION12_PARAGRAPH2,
    BLOG3_SECTION13_TITLE,
    BLOG3_SECTION13_PARAGRAPH1,
    BLOG3_SECTION13_PARAGRAPH2,
    BLOG3_SECTION14_TITLE,
    BLOG3_SECTION14_PARAGRAPH1,
    BLOG3_SECTION14_PARAGRAPH2,
    BLOG3_SECTION14_PARAGRAPH3,
    BLOG3_SECTION18_TITLE,
    BLOG3_SECTION18_PARAGRAPH1,
    BLOG3_SECTION18_PARAGRAPH2,
    BLOG3_SECTION19_TITLE,
    BLOG3_SECTION19_PARAGRAPH1,
    BLOG3_SECTION19_PARAGRAPH2,
    BLOG3_SECTION15_TITLE,
    BLOG3_SECTION15_PARAGRAPH1,
    BLOG3_SECTION15_PARAGRAPH2,
    BLOG3_SECTION15_PARAGRAPH3,
    BLOG3_SECTION15_PARAGRAPH4,
    BLOG3_SECTION15_PARAGRAPH5,
    BLOG3_SECTION16_TITLE,
    BLOG3_SECTION16_TABLE_HEADER1,
    BLOG3_SECTION16_TABLE_HEADER2,
    BLOG3_SECTION16_ROW1_COL1,
    BLOG3_SECTION16_ROW2_COL1,
    BLOG3_SECTION16_ROW3_COL1,
    BLOG3_SECTION16_ROW4_COL1,
    BLOG3_SECTION16_ROW5_COL1,
    BLOG3_SECTION16_ROW6_COL1,
    BLOG3_SECTION16_ROW7_COL1,
    BLOG3_SECTION16_ROW8_COL1,
    BLOG3_SECTION16_ROW9_COL1,
    BLOG3_SECTION16_ROW10_COL1,
    BLOG3_SECTION16_ROW11_COL1,
    BLOG3_SECTION16_ROW12_COL1,
    BLOG3_SECTION16_ROW13_COL1,
    BLOG3_SECTION16_ROW14_COL1,
    BLOG3_SECTION16_ROW1_COL2,
    BLOG3_SECTION16_ROW2_COL2,
    BLOG3_SECTION16_ROW3_COL2,
    BLOG3_SECTION16_ROW4_COL2,
    BLOG3_SECTION16_ROW5_COL2,
    BLOG3_SECTION16_ROW6_COL2,
    BLOG3_SECTION16_ROW7_COL2,
    BLOG3_SECTION16_ROW8_COL2,
    BLOG3_SECTION16_ROW9_COL2,
    BLOG3_SECTION16_ROW10_COL2,
    BLOG3_SECTION16_ROW11_COL2,
    BLOG3_SECTION16_ROW12_COL2,
    BLOG3_SECTION16_ROW13_COL2,
    BLOG3_SECTION16_ROW14_COL2,
    BLOG3_SECTION17_TITLE,
    BLOG3_SECTION17_SUBTITLE1,
    BLOG3_SECTION17_PARAGRAPH1,
    BLOG3_SECTION17_SUBTITLE2,
    BLOG3_SECTION17_PARAGRAPH2,
    BLOG3_SECTION17_SUBTITLE3,
    BLOG3_SECTION17_PARAGRAPH3,
    BLOG3_SECTION17_SUBTITLE4,
    BLOG3_SECTION17_PARAGRAPH4,
    //====BLOG4
    BLOG4_TITLE,
    BLOG4_DISPLAY_TITLE,
    BLOG4_SECTION1_TITLE,
    BLOG4_SECTION1_PARAGRAPH1,
    BLOG4_SECTION1_PARAGRAPH2,
    BLOG4_SECTION1_PARAGRAPH3,
    BLOG4_SECTION2_TITLE,
    BLOG4_SECTION2_PARAGRAPH1,
    BLOG4_SECTION2_PARAGRAPH2,
    BLOG4_SECTION2_TABLE_HEADER1,
    BLOG4_SECTION2_TABLE_HEADER2,
    BLOG4_SECTION2_TABLE_HEADER3,
    BLOG4_SECTION2_ROW1_COL1,
    BLOG4_SECTION2_ROW1_COL2,
    BLOG4_SECTION2_ROW1_COL3,
    BLOG4_SECTION2_ROW2_COL1,
    BLOG4_SECTION2_ROW2_COL2,
    BLOG4_SECTION2_ROW2_COL3,
    BLOG4_SECTION2_ROW3_COL1,
    BLOG4_SECTION2_ROW3_COL2,
    BLOG4_SECTION2_ROW3_COL3,
    BLOG4_SECTION2_ROW4_COL1,
    BLOG4_SECTION2_ROW4_COL2,
    BLOG4_SECTION2_ROW4_COL3,
    BLOG4_SECTION2_ROW5_COL1,
    BLOG4_SECTION2_ROW5_COL2,
    BLOG4_SECTION2_ROW5_COL3,
    BLOG4_SECTION2_ROW6_COL1,
    BLOG4_SECTION2_ROW6_COL2,
    BLOG4_SECTION2_ROW6_COL3,
    BLOG4_SECTION3_TITLE,
    BLOG4_SECTION3_PARAGRAPH1,
    BLOG4_SECTION3_PARAGRAPH2,
    BLOG4_SECTION3_PARAGRAPH3,
    BLOG4_SECTION4_TITLE,
    BLOG4_SECTION4_PARAGRAPH1,
    BLOG4_SECTION4_PARAGRAPH2,
    BLOG4_SECTION5_TITLE,
    BLOG4_SECTION5_PARAGRAPH1,
    BLOG4_SECTION5_PARAGRAPH2,
    BLOG4_SECTION6_TITLE,
    BLOG4_SECTION6_PARAGRAPH1,
    BLOG4_SECTION6_PARAGRAPH2,
    BLOG4_SECTION7_TITLE,
    BLOG4_SECTION7_PARAGRAPH1,
    BLOG4_SECTION7_PARAGRAPH2,
    BLOG4_SECTION8_TITLE,
    BLOG4_SECTION8_PARAGRAPH1,
    BLOG4_SECTION8_POINT1,
    BLOG4_SECTION8_POINT2,
    BLOG4_SECTION8_POINT3,
    BLOG4_SECTION8_POINT4,
    BLOG4_SECTION8_POINT5,
    BLOG4_SECTION8_POINT6,
    BLOG4_SECTION8_PARAGRAPH2,
    BLOG4_SECTION9_TITLE,
    BLOG4_SECTION9_PARAGRAPH1,
    BLOG4_SECTION9_PARAGRAPH2,
    BLOG4_SECTION9_PARAGRAPH3,
    BLOG4_SECTION10_TITLE,
    BLOG4_SECTION10_PARAGRAPH1,
    BLOG4_SECTION10_TABLE_HEADER1,
    BLOG4_SECTION10_TABLE_HEADER2,
    BLOG4_SECTION10_TABLE_HEADER3,
    BLOG4_SECTION10_ROW1_COL1,
    BLOG4_SECTION10_ROW1_COL2,
    BLOG4_SECTION10_ROW1_COL3,
    BLOG4_SECTION10_ROW2_COL1,
    BLOG4_SECTION10_ROW2_COL2,
    BLOG4_SECTION10_ROW2_COL3,
    BLOG4_SECTION10_ROW3_COL1,
    BLOG4_SECTION10_ROW3_COL2,
    BLOG4_SECTION10_ROW3_COL3,
    BLOG4_SECTION10_ROW4_COL1,
    BLOG4_SECTION10_ROW4_COL2,
    BLOG4_SECTION10_ROW4_COL3,
    BLOG4_SECTION10_ROW5_COL1,
    BLOG4_SECTION10_ROW5_COL2,
    BLOG4_SECTION10_ROW5_COL3,
    BLOG4_SECTION10_ROW6_COL1,
    BLOG4_SECTION10_ROW6_COL2,
    BLOG4_SECTION10_ROW6_COL3,
    BLOG4_SECTION10_ROW7_COL1,
    BLOG4_SECTION10_ROW7_COL2,
    BLOG4_SECTION10_ROW7_COL3,
    BLOG4_SECTION10_PARAGRAPH2,
    BLOG4_SECTION11_TITLE,
    BLOG4_SECTION11_PARAGRAPH1,
    BLOG4_SECTION11_PARAGRAPH2,
    BLOG4_SECTION11_PARAGRAPH3,
    BLOG4_SECTION11_PARAGRAPH4,
    BLOG4_SECTION12_TITLE,
    BLOG4_SECTION12_SUBTITLE1,
    BLOG4_SECTION12_PARAGRAPH1,
    BLOG4_SECTION12_SUBTITLE2,
    BLOG4_SECTION12_PARAGRAPH2,
    BLOG4_SECTION12_SUBTITLE3,
    BLOG4_SECTION12_PARAGRAPH3,
    BLOG4_SECTION12_SUBTITLE4,
    BLOG4_SECTION12_PARAGRAPH4,
    BLOG4_SECTION12_SUBTITLE5,
    BLOG4_SECTION12_PARAGRAPH5,
    //==========BLOG END==========
    ;

    override val keyName: String
        get() = name
}


// 4. A map to hold all translations, keyed by language
val TextResources = mapOf(
    Language.EN to mapOf(
        ResKey.NAV_TRADES to "Trades",
        ResKey.NAV_BUILDER to "Builder",
        ResKey.NAV_TEMPLATES to "Designs",
        ResKey.NAV_TEMPLATES_SUBTITLE to "Choose the best one for you",
        ResKey.NAV_PORTAL_SUBITEM to "Job Management Portal",
        ResKey.NAV_SEO_SERVICES_SUBITEM to "SEO Services",

        ResKey.NAV_HOME to "Home",
        ResKey.NAV_PRICES to "Pricing",
        ResKey.NAV_BLOG to "Blog",
        ResKey.NAV_CONTACT to "Contact me",
        ResKey.NAV_ABOUT to "About",
        ResKey.NAV_FAQ to "FAQ",


        ResKey.PLACEHOLDER_SERVICE_TEXT to "Your service text here",
        ResKey.PLACEHOLDER_SERVICE_TITLE to "Your service title here",
        ResKey.PLACEHOLDER_VALUES to "Your values text",
        ResKey.PLACEHOLDER_SECONDARY_BUTTON to "See my products",
        ResKey.PLACEHOLDER_ABOUT_TITLE to "About your company title",
        ResKey.PLACEHOLDER_ABOUT_LONGER_TEXT to "This is a placeholder text for your company history, values, and background information. It is intended to give an overview of your organization’s journey, mission, and growth over time. Replace this section with details about your company’s origins, key milestones, achievements, and the principles that define your brand and guide its future direction.",
        ResKey.PLACEHOLDER_ABOUT_LONGER_TEXT2 to "This is a placeholder text for your company history, values, and background information. It is intended to give an overview of your organization’s journey, mission, and growth over time.",
        ResKey.PLACEHOLDER_ABOUT_TEXT to "Text about your company",
        ResKey.PLACEHOLDER_REVIEWS_TITLE to "Reviews title",
        ResKey.PLACEHOLDER_QUESTION to "Question",
        ResKey.PLACEHOLDER_ANSWER to "Answer",
        ResKey.PLACEHOLDER_SLOGAN to "Your company slogan or motto here",
        ResKey.PLACEHOLDER_REVIEW_TITLE to "Review title",
        ResKey.PLACEHOLDER_REVIEW_DESC to "Your customer's review text",
        ResKey.PLACEHOLDER_REVIEW_NAME to "Your customer's review name",
        ResKey.PLACEHOLDER_COMPANY_NAME to "Your company name",
        ResKey.PLACEHOLDER_SERVICE_PRICE to "Your service price",
        ResKey.PLACEHOLDER_SERVICE_TIME to "Your service time",
        ResKey.PLACEHOLDER_PRODUCT_TYPE to "Your product type",
        ResKey.PLACEHOLDER_PRODUCT_TITLE to "Your product name",
        ResKey.PLACEHOLDER_PRODUCTS_MAIN_TITLE to "Your products description",
        ResKey.PLACEHOLDER_PRODUCT_DESC to "Your product description",
        ResKey.PLACEHOLDER_PRODUCT_PRICE to "Your product price",
        ResKey.PLACEHOLDER_PROJECT_DESC to "This is a placeholder text for your project description. It is intended to provide a brief overview of the project’s purpose, scope, and key objectives. Replace this section with details about the project goals, timeline, deliverables, and any important features or outcomes that highlight its value and impact.",
        ResKey.PLACEHOLDER_PROJECT_TITLE to "Your project title",
        ResKey.PLACEHOLDER_ACHIEVEMENT to "Your stats",
        ResKey.PLACEHOLDER_EXPERIENCE to "Your experience",
        ResKey.PLACEHOLDER_TIMETABLE to "Your timetable",
        ResKey.PLACEHOLDER_OPTION to "Option %s",
        ResKey.PLACEHOLDER_CONTACT_PLACEHOLDER to "Field placeholder",
        ResKey.PLACEHOLDER_CONTACT_LABEL to "Field label",
        ResKey.PLACEHOLDER_EMPTY to "",


        ResKey.BUILDER_PAGE_TITLE to "Website builder for sole traders in the UK - build your website without coding",
        ResKey.BUILDER_PAGE_SUBTITLE to "Create a professional website for your sole trader business using a simple, section-based website builder. Choose the sections you need, arrange them in any order, preview your website, and then I will customise it with your branding before it goes live.",
        ResKey.BUILDER_INFO1_TITLE to "Build your website using sections",
        ResKey.BUILDER_INFO1_SUBTITLE to "Instead of fixed templates, this website builder lets you build your website section by section. You decide what to include based on your business. For example:",
        ResKey.BUILDER_INFO1_POINT1 to "Services section explaining what you offer",
        ResKey.BUILDER_INFO1_POINT2 to "About section for your experience",
        ResKey.BUILDER_INFO1_POINT3 to "Testimonials and customer reviews",
        ResKey.BUILDER_INFO1_POINT4 to "Gallery or previous work showcase",
        ResKey.BUILDER_INFO1_POINT5 to "Pricing or quote request section",
        ResKey.BUILDER_INFO1_POINT6 to "FAQ section for customer questions",

        ResKey.BUILDER_INFO2_TITLE to "Drag and drop to arrange your layout",
        ResKey.BUILDER_INFO2_SUBTITLE to "Easily create your website structure by selecting sections and using a drag and drop to change the order. No technical skills required.",
        ResKey.BUILDER_INFO2_POINT1 to "Select sections you would like to include",
        ResKey.BUILDER_INFO2_POINT2 to "Move sections up or down instantly",
        ResKey.BUILDER_INFO2_POINT3 to "Build your layout visually",
        ResKey.BUILDER_INFO2_POINT4 to "Experiment with different structures",
        ResKey.BUILDER_INFO2_POINT5 to "Full flexibility over your design",

        ResKey.BUILDER_INFO3_TITLE to "Preview your website before it’s customised and published",
        ResKey.BUILDER_INFO3_SUBTITLE to "You can instantly preview your website as you build it to see how it will look. After you finish building your layout:",
        ResKey.BUILDER_INFO3_POINT1 to "I manually customise your website",
        ResKey.BUILDER_INFO3_POINT2 to "I add your sole trader branding, logo, images, and text",
        ResKey.BUILDER_INFO3_POINT3 to "I refine the design for your business",
        ResKey.BUILDER_INFO3_POINT4 to "I ensure everything is ready before publishing",
        ResKey.BUILDER_INFO3_POINT5 to "Your website does not go live automatically, it is professionally finalised before launch",

        ResKey.BUILDER_INFO4_TITLE to "Professional website customisation for sole traders",
        ResKey.BUILDER_INFO4_SUBTITLE to "Once you’re happy with your structure, I take over the final build and customise everything for your business. I will add:",
        ResKey.BUILDER_INFO4_POINT1 to "Your logo and branding",
        ResKey.BUILDER_INFO4_POINT2 to "Your real business images",
        ResKey.BUILDER_INFO4_POINT3 to "Your written content and details",
        ResKey.BUILDER_INFO4_POINT4 to "Trade-specific adjustments for UK customers",
        ResKey.BUILDER_INFO4_POINT5 to "SEO optimisation for your location and services",

        ResKey.BUILDER_INFO5_TITLE to "Launch a professional website that gets you more enquires",
        ResKey.BUILDER_INFO5_POINT1 to "Built for UK local SEO",
        ResKey.BUILDER_INFO5_POINT2 to "Helps generate more calls and enquiries",
        ResKey.BUILDER_INFO5_POINT3 to "Simple structure, professionally finished",
        ResKey.BUILDER_INFO5_POINT4 to "Fully responsive on all devices",
        ResKey.BUILDER_INFO5_POINT5 to "More calls, more leads, more jobs!",
        ResKey.BUILDER_FINAL_TITLE to "Build your layout. I’ll handle the rest",
        ResKey.BUILDER_FINAL_SUBTITLE to "Use the builder to choose your sections and I’ll professionally customise and prepare your website for launch.",
        ResKey.BUILDER_PREVIEW_OPTIONS to "Preview options:",
        ResKey.BUILDER_PREVIEW_TOOLTIP_DRAG to "Drag and drop to change the order",
        ResKey.BUILDER_PREVIEW_TOOLTIP_CONTENT to "Displays example text and images so you can preview the website with realistic content",
        ResKey.BUILDER_PREVIEW_TOOLTIP_PLACEHOLDER to "Shows placeholder sections and images to help visualise the website structure and layout",
        ResKey.BUILDER_CURRENT_SELECTION to "Current selection",









        //  ResKey.ABOUT_SECTION2_SUBTITLE2 to "I founded Anjuros Development Limited to help sole traders and contractors get straightforward, professional websites without unnecessary complexity. My background is in Android development, and I apply that same problem-solving mindset to build websites that load quickly, look professional, and help generate enquiries. I focus on clear communication and solutions that don’t require ongoing technical headaches.",







        ResKey.FAQ1_Q to "Why does a sole trader need a website?",
        ResKey.FAQ1_A to "A professional website helps potential customers find your business online, view your services, read reviews, see previous work and contact you easily. Unlike social media, your website is your own online presence that you control and can use to generate enquiries 24/7.",

        ResKey.FAQ2_Q to "Will my website appear on Google?",
        ResKey.FAQ2_A to "Yes. Your website will be submitted to Google and built using SEO best practices, including proper page structure, meta information, mobile optimisation and fast loading times. This helps search engines find and index your website. Every website also includes SEO to help improve your visibility on Google over time.",

        ResKey.FAQ3_Q to "Do you provide SEO?",
        ResKey.FAQ3_A to "Yes. SEO is included with every website. This includes technical SEO, search engine optimisation, ongoing improvements and guidance to help your business appear higher in local search results. <a href=\"/seo-services\">Learn more about SEO services</a>",

        ResKey.FAQ4_Q to "Can customers contact me directly from my website?",
        ResKey.FAQ4_A to "Yes. Your website includes professional contact forms that send enquiries directly to you. If you choose the Pro Service Plan, every enquiry is also automatically added to your private Job Management Portal, helping you keep track of new jobs without any manual work.",

        ResKey.FAQ5_Q to "What is the Job Management Portal?",
        ResKey.FAQ5_A to "The Job Management Portal is a private online space designed specifically for sole traders. It allows you to manage enquiries, contact customers, schedule jobs, upload before and after photos, request reviews, send payment requests, record job duration and keep all your work organised from your phone or computer. <a href=\"/job-management-portal\">Learn more about Job Management Portal</a>",

        ResKey.FAQ6_Q to "Can I use the Job Management Portal if I already have a website?",
        ResKey.FAQ6_A to "Yes. If you already have a website built with WordPress, Wix, Squarespace or another platform, the portal can still be connected to your existing contact forms or new forms can be added. This means you can benefit from the Job Management Portal without replacing your current website.",

        ResKey.FAQ7_Q to "How long does it take to build my website?",
        ResKey.FAQ7_A to "Most template-based websites are ready within a few days of receiving your content. Custom websites or additional features may take longer depending on the project. I will keep you updated throughout the process.",

        ResKey.FAQ8_Q to "Will my website work on mobile phones and tablets?",
        ResKey.FAQ8_A to "Yes. Every website is fully responsive and designed to work smoothly on mobile phones, tablets and desktop computers. It is also tested to provide a great experience across modern devices.",

        ResKey.FAQ9_Q to "Can you redesign my existing website?",
        ResKey.FAQ9_A to "Yes. Whether you have an outdated website or simply want a more modern design, I can redesign your existing website while keeping your business information, branding and goals in mind. I can also improve its speed, SEO and user experience.",

        ResKey.FAQ10_Q to "Can I keep my existing domain name?",
        ResKey.FAQ10_A to "Yes. If you already own a domain name, it can usually be connected to your new website. If you don't have one, I can help you choose and register a suitable domain name for your business.",

        ResKey.FAQ11_Q to "What happens after my website is finished?",
        ResKey.FAQ11_A to "Your website remains online and supported with one of our maintenance plans, so you can choose the level of support that best suits your business. The Basic Care Plan includes secure hosting, domain renewal, an SSL certificate, regular backups and contact form delivery to your email. The Care Plan adds ongoing website updates and regular SEO improvements to help increase your visibility on Google. The Pro Service Plan includes everything in the Care Plan, plus priority support, advanced SEO and access to your private Job Management Portal, allowing you to manage enquiries, jobs, reviews and customer communications from your phone or computer. You can upgrade or change your plan at any time as your business grows. <a href=\"/prices\">Learn more about plans</a>",

        ResKey.FAQ12_Q to "Can a website help me get more customers?",
        ResKey.FAQ12_A to "Yes. A professional website builds trust, improves your visibility on Google and gives potential customers an easy way to contact you. Combined with SEO, customer reviews and a fast, mobile-friendly design, your website can become one of your most valuable sources of new enquiries.",

        ResKey.FAQ13_Q to "Can customers book jobs online?",
        ResKey.FAQ13_A to "Yes. Customers can send enquiries through your website at any time using your contact forms. Every enquiry is delivered directly to your email, regardless of which plan you choose. If you have the Pro Service Plan, every enquiry is also automatically added to your Job Management Portal, making it quick and easy to follow up, schedule work and manage your jobs.",

        ResKey.FAQ14_Q to "Do I need technical knowledge to manage my website?",
        ResKey.FAQ14_A to "No. I take care of the technical side, including hosting, maintenance, security updates and SEO.",

        ResKey.FAQ15_Q to "What types of businesses do you build websites for?",
        ResKey.FAQ15_A to "I specialise in websites for UK sole traders, including plumbers, electricians, builders, handymen, decorators, gardeners, cleaners and many other local service businesses. I also create websites for small businesses, charities, community organisations and professional portfolios.",

        ResKey.SEE_ALL_TEMPLATES to "See all designs",
        ResKey.MIX_CONTENT_TEXT to "CONTENT MODE",
        ResKey.MIX_PLACEHOLDER_TEXT to "PLACEHOLDER MODE",

        ResKey.TEMPLATE_NEXTSTEP2_BUTTON_TEXT to "Start building",
        ResKey.TEMPLATE_NEXTSTEP2_BUTTON2_TEXT to "See more",


        ResKey.WORK_WITH_ELECTRICIAN_TITLE to "Electrician website design",
        ResKey.WORK_WITH_HANDYMAN_TITLE to "Handyman website design",
        ResKey.WORK_WITH_PAINTER_TITLE to "Decorator website design",
        ResKey.WORK_WITH_HAIDRESSER_TITLE to "Hairdresser website design",
        ResKey.WORK_WITH_DOGWALKER_TITLE to "Dog walker website design",
        ResKey.WORK_WITH_BAKER_TITLE to "Baker website design",
        ResKey.WORK_WITH_INSTRUCTOR_TITLE to "Instructor website design",
        ResKey.WORK_WITH_PUB_TITLE to "Pub website design",


        ResKey.PRIVACY_POLICY_SEE to "See our Privacy Policy",
        ResKey.PRIVACY_POLICY_TITLE to "Privacy Policy",
        ResKey.PRIVACY_POLICY_LAST_UPDATED to "Last updated: February 2026",

        ResKey.PRIVACY_POLICY_SECTION1_TITLE to "1. Introduction",
        ResKey.PRIVACY_POLICY_SECTION1_TEXT1 to "This Privacy Policy explains how Anjuros Development (\"we\", \"us\", \"our\") collects, uses, and protects your information when you visit www.soletraderwebsite.co.uk.",
        ResKey.PRIVACY_POLICY_SECTION1_TEXT2 to "We are committed to protecting your personal data and respecting your privacy.",

        ResKey.PRIVACY_POLICY_SECTION2_TITLE to "2. Data Controller",
        ResKey.PRIVACY_POLICY_SECTION2_BUSINESS to "Business Name: Anjuros Development",
        ResKey.PRIVACY_POLICY_SECTION2_EMAIL to "Email: contact@anjurosdevelopment.com",

        ResKey.PRIVACY_POLICY_SECTION3_TITLE to "3. Information We Collect",

        ResKey.PRIVACY_POLICY_SECTION3A_TITLE to "a) Information You Provide Voluntarily",
        ResKey.PRIVACY_POLICY_SECTION3A_TEXT1 to "When you submit our contact form, we collect your name, email address, and any message you include. This information is processed via Formspree and used solely to respond to your inquiry.",
        ResKey.PRIVACY_POLICY_SECTION3A_TEXT2 to "We do not sell or share your personal data for marketing purposes.",

        ResKey.PRIVACY_POLICY_SECTION3B_TITLE to "b) Embedded YouTube Videos",
        ResKey.PRIVACY_POLICY_SECTION3B_TEXT1 to "Our website may include embedded YouTube videos using YouTube’s privacy-enhanced mode (youtube-nocookie.com domain). When interacting with these videos, YouTube may collect information such as your IP address and device data.",
        ResKey.PRIVACY_POLICY_SECTION3B_TEXT2 to "For more information, please review Google's Privacy Policy: https://policies.google.com/privacy",

        ResKey.PRIVACY_POLICY_SECTION4_TITLE to "4. Legal Basis for Processing (EU Visitors)",
        ResKey.PRIVACY_POLICY_SECTION4_TEXT1 to "If you are located in the European Economic Area (EEA), we process your personal data based on your consent (contact form submission) and our legitimate interest in responding to inquiries.",

        ResKey.PRIVACY_POLICY_SECTION5_TITLE to "5. Data Retention",
        ResKey.PRIVACY_POLICY_SECTION5_TEXT1 to "We retain contact form submissions only as long as necessary to respond to your inquiry or comply with legal obligations.",

        ResKey.PRIVACY_POLICY_SECTION6_TITLE to "6. Data Sharing",
        ResKey.PRIVACY_POLICY_SECTION6_TEXT1 to "We share data only with trusted service providers necessary to operate our website: Formspree.",

        ResKey.PRIVACY_POLICY_SECTION7_TITLE to "7. Your Rights (EU & UK Visitors)",
        ResKey.PRIVACY_POLICY_SECTION7_TEXT1 to "You have the right to access, correct, delete, or restrict processing of your personal data, and to withdraw consent at any time.",

        ResKey.PRIVACY_POLICY_SECTION8_TITLE to "8. Data Security",
        ResKey.PRIVACY_POLICY_SECTION8_TEXT1 to "We take reasonable technical and organizational measures to protect your personal data.",

        ResKey.PRIVACY_POLICY_SECTION9_TITLE to "9. Changes to This Policy",
        ResKey.PRIVACY_POLICY_SECTION9_TEXT1 to "We may update this Privacy Policy from time to time. Updates will be posted on this page with a revised \"Last updated\" date.",




        ResKey.TEMPLATE1 to "Hairdresser website design",
        ResKey.TEMPLATE1_SUBTITLE to "Modern layout to showcase services, pricing, and portfolio",
        ResKey.TEMPLATE1_HEADER to "Hairdresser website design for UK sole traders",
        ResKey.TEMPLATE1_SUBHEADER to "A modern website design for hairdressers that I customise with your services, pricing, content, and branding to help you get more bookings.",

        ResKey.TEMPLATE2 to "Handyman website design",
        ResKey.TEMPLATE2_SUBTITLE to "Professional layout to present services and get more enquiries",
        ResKey.TEMPLATE2_HEADER to "Handyman website design for UK sole traders",
        ResKey.TEMPLATE2_SUBHEADER to "A clear and professional website design for handymen, customised with your services, content, and branding to help you get more local jobs.",


        ResKey.TEMPLATE9 to "Dog walker website design",
        ResKey.TEMPLATE9_SUBTITLE to "Playful, modern website concept for dog walkers and pet sitters",
        ResKey.TEMPLATE9_HEADER to "Modern dog walker website design for UK sole traders",
        ResKey.TEMPLATE9_SUBHEADER to "A playful, modern dog walker website, personalised to help you win more local clients.",

        ResKey.TEMPLATE10 to "Instructor website design",
        ResKey.TEMPLATE10_SUBTITLE to "Calm, modern concept for Tai Chi, yoga and fitness instructors",
        ResKey.TEMPLATE10_HEADER to "Tai Chi & instructor website design for UK sole traders",
        ResKey.TEMPLATE10_SUBHEADER to "A calm, modern instructor website with timetable, videos and venues, personalised to help you fill more classes.",

        ResKey.TEMPLATE4 to "Decorator website design",
        ResKey.TEMPLATE4_SUBTITLE to "Clean, professional look to showcase work and customer reviews",
        ResKey.TEMPLATE4_HEADER to "Decorator website design to showcase your work and win more jobs",
        ResKey.TEMPLATE4_SUBHEADER to "A professional website design for decorators, customised to highlight your projects, services, and reviews and attract more residential and commercial clients.",

        ResKey.TEMPLATE5 to "Baker website design",
        ResKey.TEMPLATE5_SUBTITLE to "Product-focused layout to showcase your products and attract orders",
        ResKey.TEMPLATE5_HEADER to "Baker website design for UK sole traders and small businesses",
        ResKey.TEMPLATE5_SUBHEADER to "A clean and inviting website design for bakers, customised to showcase your products, services, and branding and help you attract more customers.",

        ResKey.TEMPLATE6 to "Electrician website design",
        ResKey.TEMPLATE6_SUBTITLE to "Professional layout to present services and generate enquiries",
        ResKey.TEMPLATE6_HEADER to "Electrician website design for UK sole traders",
        ResKey.TEMPLATE6_SUBHEADER to "A professional website design for electricians that I customise with your services, content, and branding to help you generate more enquiries.",


        ResKey.TEMPLATE8 to "Pub website design",
        ResKey.TEMPLATE8_SUBTITLE to "Stylish website concept to showcase menus, events, and your venue",
        ResKey.TEMPLATE8_HEADER to "Pub website design to attract more customers",
        ResKey.TEMPLATE8_SUBHEADER to "A modern website design for pubs and bars, customised with your menu, events, content, and branding to help bring in more visitors.",

        ResKey.TEMPLATE8_HEADER_SUBPAGE1 to "Pub menu page design example for UK businesses",
        ResKey.TEMPLATE8_SUBHEADER_SUBPAGE1 to "A clean and easy-to-use menu layout designed to showcase your food and drinks clearly and make it easy for customers to choose what they want.",

        ResKey.TEMPLATE8_HEADER_SUBPAGE2 to "About your pub - website design example",
        ResKey.TEMPLATE8_SUBHEADER_SUBPAGE2 to "A simple and engaging page to tell your story, highlight your venue, and build trust with your customers.",

        ResKey.TEMPLATE8_HEADER_SUBPAGE3 to "What’s on page design example for pubs and bars",
        ResKey.TEMPLATE8_SUBHEADER_SUBPAGE3 to "A dynamic page to promote events, live music, and special offers, helping you bring more people through the door.",


        ResKey.TEMPLATE_MIX to "Custom website builder",
        ResKey.TEMPLATE_MIX_SUBTITLE to "Flexible builder to mix sections and create a custom website",











        ResKey.CONTACT_NAME_LABEL to "Name",
        ResKey.CONTACT_NAME to "Full Name",
        ResKey.CONTACT_EMAIL_LABEL to "Email",
        ResKey.CONTACT_EMAIL to "Email Address",
        ResKey.CONTACT_REFERRAL_CODE_LABEL to "Referral Code",
        ResKey.CONTACT_REFERRAL_CODE to "Referral Code",
        ResKey.CONTACT_PHONE_LABEL to "Phone Number",
        ResKey.CONTACT_PHONE to "Phone",
        ResKey.CONTACT_VALIDATION_SPAM to "Please complete the verification check.",
        ResKey.SPAM_PROTECTION_INFO_TITLE to "Spam protection",
        ResKey.SPAM_PROTECTION_INFO_SUBTITLE to "Enabled on live website to help block spam and bots",
        ResKey.SPAM_PROTECTION_INFO_LEARN_MORE to "<a href=\"/contact-forms#spam\">Learn more</a>",


        ResKey.CONTACT_FORM_URGENCY_LABEL to "Urgency",
        ResKey.CONTACT_FORM_AREA_LABEL to "Which areas need work?",
        ResKey.CONTACT_FORM_WHAT_WORK_LABEL to "What work is needed?",

        ResKey.CONTACT_MESSAGE_LABEL to "Message",
        ResKey.CONTACT_MESSAGE to "Your Message",
        ResKey.CONTACT_NOTE_LABEL to "Note",
        ResKey.CONTACT_NOTE to "Your Note",











        ResKey.CONTACT_DATE_LABEL to "Preferred appointment date",
        ResKey.CONTACT_DATE to "Preferred appointment date",

        ResKey.BUTTON_CONTACT_SUBMIT to "Submit",
        ResKey.BUTTON_CONTACT_SUBMIT_DEMO to "Submit (Demo)",

        ResKey.TEMPLATE_MIX_HEADER_TITLE to "Headers",
        ResKey.TEMPLATE_MIX_HEADER to "Header",
        ResKey.TEMPLATE_MIX_SERVICES_TITLE to "Services",
        ResKey.TEMPLATE_MIX_SERVICE to "Service",
        ResKey.TEMPLATE_MIX_PRICES_TIMETABLES to "Prices & Timetables",
        ResKey.TEMPLATE_MIX_PRICES to "Prices",
        ResKey.TEMPLATE_MIX_TIMETABLES to "Timetable",
        ResKey.TEMPLATE_MIX_REVIEWS to "Reviews",
        ResKey.TEMPLATE_MIX_FAQ to "FAQ",
        ResKey.TEMPLATE_MIX_CONTACT_TITLE to "Contacts",
        ResKey.TEMPLATE_MIX_CONTACT_FORMS_TITLE to "Contact forms",
        ResKey.TEMPLATE_MIX_CONTACT to "Contact",
        ResKey.TEMPLATE_MIX_CONTACT_FORM to "Contact form",
        ResKey.TEMPLATE_MIX_ABOUT_ME to "About Me",
        ResKey.TEMPLATE_MIX_FOOTER to "Footer",
        ResKey.TEMPLATE_MIX_FOOTERS to "Footers",
        ResKey.TEMPLATE_MIX_CATEGORIES to "Categories:",
        ResKey.TEMPLATE_MIX_YOUR_SELECTION to "Current selection: ",
        ResKey.TEMPLATE_MIX_CLEAR_ALL to "Clear all",
        ResKey.TEMPLATE_MIX_GET_THE_WEBSITE to "Message me to discuss your design",
        ResKey.TEMPLATE_MIX_CHECK_THE_WEBSITE to "Continue to summary",
        ResKey.TEMPLATE_MIX_PREVIEW_THE_WEBSITE to "Preview the website",
        ResKey.TEMPLATE_MIX_CHOOSE_THIS_SELECTION to "Choose this section",
        ResKey.TEMPLATE_MIX_CONTACT_FORM_TITLE to "Let me know which sections you want to focus on - no commitment yet!",
        ResKey.TEMPLATE_MIX_CONTACT_FORM_TITLE_SUCCESS to "Form submitted successfully! I will contact you as soon as possible.",
        ResKey.TEMPLATE_MIX_CONTACT_FORM_TITLE_SUCCESS_DEMO to "This is a template preview. No message has been sent.\n" +
                "\n" +
                "On a live website, this form would submit your customer message to you.",
        ResKey.TEMPLATE_MIX_CONTACT_FORM_MSG to "I'm interested in a website that includes: ",
        ResKey.TEMPLATE_MIX_SELECTION_INFO to "Review your custom website design",
        ResKey.TEMPLATE_MIX_SELECTION_INFO_SUBTITLE to "Here are the sections you've selected for your unique website. I’ll fully customise the design for you - including your images, text, colours, logo, and overall style. Review everything and click on {b}Message me{/b}  to discuss your design when you're ready. Messaging me is just the first step and doesn’t commit you to anything yet. ",
        ResKey.TEMPLATE_MIX_SELECTION_INFO_EMPTY to "Begin your custom website design",
        ResKey.TEMPLATE_MIX_SELECTION_INFO_SUBTITLE_EMPTY to "To get started, please explore the categories available on the left panel. Click a category and then the checkboxes to select the sections you would like to include in your unique website. Your selection will appear in the {b}Summary{/b} for review.",
        ResKey.TEMPLATE_MIX_SELECTION_MESSAGE_EMPTY to "Selected sections will be shown here after you make choices from the categories on the left side",
        ResKey.TEMPLATE_MIX_SELECTION_INFO_SUBTITLE_EMPTY_MOBILE to "To get started, please explore the categories available on the top panel underneath the {b}Selection{/b} option. Click a category and then the checkboxes to select the sections you would like to include in your unique website. Your selections will then appear in the {b}Summary{/b} for review.",
        ResKey.TEMPLATE_MIX_SELECTION_MESSAGE_EMPTY_MOBILE to "Selected sections will be shown here after you make choices from the categories on the top",


        ResKey.CONTACT_FORM_REQUIRED to "%s is required.",
        ResKey.CONTACT_FORM_EMAIL_VALID to "Please enter a valid email address.",
        ResKey.CONTACT_FORM_PHONE_VALID to "Please enter a valid phone number (e.g. 07123456789)",
        ResKey.TEXT_CONTACT_FORM_ERROR to "Something went wrong. Please try again.",
        ResKey.CONTACT_FORM_SENDING to "Sending...",

        ResKey.TEMPLATE_MIX_SECTION10 to "Show products you are selling",
        ResKey.TEMPLATE_MIX_SECTION11 to "Show detailed prices",

        ResKey.TEMPLATE_MIX_HEADER_SUMMARY_SUBTITLE to "Modern navigation",
        ResKey.TEMPLATE_MIX_ABOUTME_SUMMARY_SUBTITLE to "Your professional story",
        ResKey.TEMPLATE_MIX_SERVICES_SUMMARY_SUBTITLE to "Detailed solution offering",
        ResKey.TEMPLATE_MIX_PRICES_SUMMARY_SUBTITLE to "Transparent pricing plans",
        ResKey.TEMPLATE_MIX_TIMETABLE_SUMMARY_SUBTITLE to "Your availability",
        ResKey.TEMPLATE_MIX_REVIEWS_SUMMARY_SUBTITLE to "Verified client feedback",
        ResKey.TEMPLATE_MIX_FAQ_SUMMARY_SUBTITLE to "Frequently asked questions",
        ResKey.TEMPLATE_MIX_CONTACT_SUMMARY_SUBTITLE to "Phone & email details",
        ResKey.TEMPLATE_MIX_CONTACT_FORM_SUMMARY_SUBTITLE to "Easy ways to get in touch",
        ResKey.TEMPLATE_MIX_FOOTER_SUMMARY_SUBTITLE to "Essential site information",
        ResKey.TEMPLATE_MIX_NAV_STEP1 to "1. Selection",
        ResKey.TEMPLATE_MIX_NAV_STEP2 to "2. Summary",
        ResKey.TEMPLATE_MIX_NAV_STEP3 to "3. Preview",
        ResKey.TEMPLATE_MIX_NAV_STEP4 to "4. Message me",
        ResKey.TEMPLATE_MIX_NAV_STEP4_SHORT to "4. Message",














































































        //BLOG==================
        ResKey.BLOG1_TITLE to "Why every sole trader needs a website",

        ResKey.BLOG1_SECTION1_TITLE to "Introduction",

        ResKey.BLOG1_SECTION1_PARAGRAPH1 to "If you're a sole trader, you've probably wondered whether you really need a website.",

        ResKey.BLOG1_SECTION1_PARAGRAPH2 to "Perhaps you already have a Facebook page, an Instagram account or receive most of your work through recommendations. If your diary is reasonably full, paying for a website might seem like an unnecessary expense.",

        ResKey.BLOG1_SECTION1_PARAGRAPH3 to "The reality is that customers expect businesses to have a professional online presence. A website isn't just somewhere to display your phone number. It's one of the best tools for helping new customers to find you, trust you and get in touch.",

        ResKey.BLOG1_SECTION1_PARAGRAPH4 to "Whether you're a plumber, electrician, builder, gardener, decorator, cleaner or any other local tradesmen, a professional website can help your business grow.",


        ResKey.BLOG1_SECTION2_TITLE to "Most customers search online before contacting a business",

        ResKey.BLOG1_SECTION2_PARAGRAPH1 to "Think about the last time you needed a local service. There's a good chance you searched Google before deciding who to call. Your customers do exactly the same.",

        ResKey.BLOG1_SECTION2_PARAGRAPH2 to "They search for things like:",

        ResKey.BLOG1_SECTION2_LIST1 to "Plumber near me",
        ResKey.BLOG1_SECTION2_LIST2 to "Electrician in Bristol",
        ResKey.BLOG1_SECTION2_LIST3 to "Gardener in Leeds",
        ResKey.BLOG1_SECTION2_LIST4 to "Emergency locksmith",

        ResKey.BLOG1_SECTION2_PARAGRAPH3 to "If your business doesn't appear, they'll simply contact someone else.",

        ResKey.BLOG1_SECTION2_PARAGRAPH4 to "A professional website for your sole trader business gives you the opportunity to be found when customers are actively looking for the services you offer.",


        ResKey.BLOG1_SECTION3_TITLE to "A website helps local customers find you",

        ResKey.BLOG1_SECTION3_PARAGRAPH1 to "A well-built website isn't just about looking professional.",

        ResKey.BLOG1_SECTION3_PARAGRAPH2 to "It's also designed to help you appear in Google search results.",

        ResKey.BLOG1_SECTION3_PARAGRAPH3 to "Every website I build <a href=\"/seo-services\">includes SEO</a> (Search Engine Optimisation), helping search engines understand:",

        ResKey.BLOG1_SECTION3_LIST1 to "What services you offer",
        ResKey.BLOG1_SECTION3_LIST2 to "Where you work",
        ResKey.BLOG1_SECTION3_LIST3 to "Which areas you cover",
        ResKey.BLOG1_SECTION3_LIST4 to "How customers can contact you",

        ResKey.BLOG1_SECTION3_PARAGRAPH4 to "Combined with your Google Business Profile, customer reviews and regular updates, your website can become one of your biggest sources of new enquiries.",

        ResKey.BLOG1_SECTION3_PARAGRAPH5 to "Unlike paid advertising, good SEO continues working long after your website has been published.",
        ResKey.BLOG1_SECTION4_TITLE to "Your website works even when you don't",

        ResKey.BLOG1_SECTION4_PARAGRAPH1 to "Unlike you, your website never finishes for the day.",

        ResKey.BLOG1_SECTION4_PARAGRAPH2 to "Potential customers often look for local tradespeople during the evening, at weekends or while you're busy on another job.",

        ResKey.BLOG1_SECTION4_PARAGRAPH3 to "While you're working, your website can:",

        ResKey.BLOG1_SECTION4_LIST1 to "Showcase your services",
        ResKey.BLOG1_SECTION4_LIST2 to "Display your previous work",
        ResKey.BLOG1_SECTION4_LIST3 to "Answer common questions",
        ResKey.BLOG1_SECTION4_LIST4 to "Collect enquiries through your <a href=\"/contact-forms\">contact form</a>",

        ResKey.BLOG1_SECTION4_PARAGRAPH4 to "By the time you've finished your current job, your next customer could already be waiting.",


        ResKey.BLOG1_SECTION5_TITLE to "It builds trust before you even answer the phone",

        ResKey.BLOG1_SECTION5_PARAGRAPH1 to "A professional website tells customers you're serious about your business.",

        ResKey.BLOG1_SECTION5_PARAGRAPH2 to "It gives them somewhere to:",

        ResKey.BLOG1_SECTION5_LIST1 to "Learn about your services",
        ResKey.BLOG1_SECTION5_LIST2 to "View before and after photos",
        ResKey.BLOG1_SECTION5_LIST3 to "Read customer reviews",
        ResKey.BLOG1_SECTION5_LIST4 to "Check the areas you cover",
        ResKey.BLOG1_SECTION5_LIST5 to "Find your contact details",

        ResKey.BLOG1_SECTION5_PARAGRAPH3 to "Many customers decide whether to contact a business within seconds.",

        ResKey.BLOG1_SECTION5_PARAGRAPH4 to "A clean, modern website creates a far better first impression than relying solely on social media.",


        ResKey.BLOG1_SECTION6_TITLE to "You're in control of your online presence",

        ResKey.BLOG1_SECTION6_PARAGRAPH1 to "Social media is useful, but you don't own it. Algorithms change. Posts disappear from people's feeds. Accounts can be restricted.",

        ResKey.BLOG1_SECTION6_PARAGRAPH2 to "Your website belongs to you.",

        ResKey.BLOG1_SECTION6_PARAGRAPH3 to "Nobody can reduce your visibility because of an algorithm update, and you're not competing with funny cat videos or adverts for someone's attention.",

        ResKey.BLOG1_SECTION6_PARAGRAPH4 to "It's your business, presented your way.",


        ResKey.BLOG1_SECTION7_TITLE to "A website can save you time",

        ResKey.BLOG1_SECTION7_PARAGRAPH1 to "Many people think a website is simply an online brochure. In reality, it can become part of how you run your business.",

        ResKey.BLOG1_SECTION7_PARAGRAPH2 to "Every enquiry submitted through your website can automatically create a new job inside your Job Management Portal. Instead of copying customer details into a notebook or searching through emails, everything is organised in one place.",

        ResKey.BLOG1_SECTION7_PARAGRAPH3 to "From your phone you can:",

        ResKey.BLOG1_SECTION7_LIST1 to "Call customers with one tap",
        ResKey.BLOG1_SECTION7_LIST2 to "Open the address in Google Maps",
        ResKey.BLOG1_SECTION7_LIST3 to "Send an \"On My Way\" text message",
        ResKey.BLOG1_SECTION7_LIST4 to "Upload before and after photos",
        ResKey.BLOG1_SECTION7_LIST5 to "Track how long jobs take",
        ResKey.BLOG1_SECTION7_LIST6 to "Request Google or Checkatrade reviews",
        ResKey.BLOG1_SECTION7_LIST7 to "Send payment requests",
        ResKey.BLOG1_SECTION7_LIST8 to "Keep notes and customer history",

        ResKey.BLOG1_SECTION7_PARAGRAPH4 to "It saves time, reduces paperwork and helps you stay organised throughout the day.",

        ResKey.BLOG1_SECTION7_PARAGRAPH5 to
                "<a href=\"/job-management-portal\">Learn more about the Job Management Portal.</a>",
        ResKey.BLOG1_SECTION8_TITLE to "Facebook is great... but it shouldn't be your only online presence",

        ResKey.BLOG1_SECTION8_PARAGRAPH1 to "Many sole traders rely almost entirely on Facebook.",

        ResKey.BLOG1_SECTION8_PARAGRAPH2 to "While Facebook is excellent for sharing recent work and engaging with existing customers, it's not a replacement for a professional website.",

        ResKey.BLOG1_SECTION8_PARAGRAPH3 to "Your website gives customers one place to:",

        ResKey.BLOG1_SECTION8_LIST1 to "Learn about your business",
        ResKey.BLOG1_SECTION8_LIST2 to "View your services",
        ResKey.BLOG1_SECTION8_LIST3 to "Read testimonials",
        ResKey.BLOG1_SECTION8_LIST4 to "Contact you",
        ResKey.BLOG1_SECTION8_LIST5 to "Find you through Google",

        ResKey.BLOG1_SECTION8_PARAGRAPH4 to "The two work best together.",

        ResKey.BLOG1_SECTION8_PARAGRAPH5 to "Facebook helps people discover your latest work, while your website helps turn visitors into customers.",


        ResKey.BLOG1_SECTION9_TITLE to "It makes your business look more professional",

        ResKey.BLOG1_SECTION9_PARAGRAPH1 to "Customers often compare several businesses before making a decision.",

        ResKey.BLOG1_SECTION9_PARAGRAPH2 to "If one business has a modern website with reviews, photos and clear contact details, while another only has a Facebook page, which would you choose?",

        ResKey.BLOG1_SECTION9_PARAGRAPH3 to "A professional website helps you stand out and gives customers confidence before they've even spoken to you.",


        ResKey.BLOG1_SECTION10_TITLE to "It grows with your business",

        ResKey.BLOG1_SECTION10_PARAGRAPH1 to "Your website doesn't have to stay the same forever.",

        ResKey.BLOG1_SECTION10_PARAGRAPH2 to "As your business grows, you can:",

        ResKey.BLOG1_SECTION10_LIST1 to "Add new services",
        ResKey.BLOG1_SECTION10_LIST2 to "Publish completed projects",
        ResKey.BLOG1_SECTION10_LIST3 to "Collect more customer reviews",
        ResKey.BLOG1_SECTION10_LIST4 to "Improve your Google rankings",
        ResKey.BLOG1_SECTION10_LIST5 to "Expand into new areas",
        ResKey.BLOG1_SECTION10_LIST6 to "Add online booking or new features",

        ResKey.BLOG1_SECTION10_PARAGRAPH3 to "Your website grows alongside your business.",


        ResKey.BLOG1_SECTION11_TITLE to "Common questions",

        ResKey.BLOG1_SECTION11_SUBTITLE1 to "Isn't a website expensive?",

        ResKey.BLOG1_SECTION11_PARAGRAPH1 to "Not when you consider the value of just one new customer. If your website generates even a few additional enquiries each month, it can quickly pay for itself.",


        ResKey.BLOG1_SECTION11_SUBTITLE2 to "I already get work through recommendations",

        ResKey.BLOG1_SECTION11_PARAGRAPH2 to "That's fantastic, but even recommended customers often search for your business online before getting in touch. A professional website reassures them they've chosen the right person.",


        ResKey.BLOG1_SECTION11_SUBTITLE3 to "Will my website work on mobile phones?",

        ResKey.BLOG1_SECTION11_PARAGRAPH3 to "Absolutely! Every website is fully responsive, meaning it works beautifully on phones, tablets and desktop computers. Most visitors will view your website on their phone, so mobile performance is always a priority.",


        ResKey.BLOG1_SECTION12_TITLE to "Website vs relying only on social media",

        ResKey.BLOG1_SECTION12_TABLE_HEADER1 to "Social Media Only",
        ResKey.BLOG1_SECTION12_TABLE_HEADER2 to "Professional Website",

        ResKey.BLOG1_SECTION12_ROW1_COL1 to "Limited control",
        ResKey.BLOG1_SECTION12_ROW1_COL2 to "You own your website",

        ResKey.BLOG1_SECTION12_ROW2_COL1 to "Difficult to appear on Google",
        ResKey.BLOG1_SECTION12_ROW2_COL2 to "Optimised for Google search",

        ResKey.BLOG1_SECTION12_ROW3_COL1 to "Basic business information",
        ResKey.BLOG1_SECTION12_ROW3_COL2 to "Showcase services, reviews and projects",

        ResKey.BLOG1_SECTION12_ROW4_COL1 to "Enquiries through messages",
        ResKey.BLOG1_SECTION12_ROW4_COL2 to "Professional <a href=\"/contact-forms\">contact forms</a>",

        ResKey.BLOG1_SECTION12_ROW5_COL1 to "Posts disappear over time",
        ResKey.BLOG1_SECTION12_ROW5_COL2 to "Permanent online presence",


        ResKey.BLOG1_SECTION13_TITLE to "Is a website worth it?",

        ResKey.BLOG1_SECTION13_PARAGRAPH1 to "For almost every sole trader, a professional website is one of the best investments you can make. It helps potential customers find you on Google, builds trust before they even pick up the phone and gives your business a professional online presence that works around the clock. Even if most of your work comes from recommendations, many customers will still search for your business online before getting in touch. A modern website gives them the confidence that they're choosing the right person.",


        ResKey.BLOG1_SECTION14_TITLE to "Ready to grow your business?",

        ResKey.BLOG1_SECTION14_PARAGRAPH1 to "A website is often the first impression potential customers have of your business.",

        ResKey.BLOG1_SECTION14_PARAGRAPH2 to "It's more than an online brochure. It's a tool that helps you generate enquiries, build trust, improve your visibility on Google and manage your business more efficiently.",

        ResKey.BLOG1_SECTION14_PARAGRAPH3 to "Whether you're just starting out or replacing an outdated website, investing in a professional website is one of the smartest decisions you can make for your business.",

        ResKey.BLOG1_SECTION14_PARAGRAPH4 to "Find out more about our <a href=\"/website-templates-uk\">website design services</a>, compare our website <a href=\"/website-design-pricing-uk\">maintenance plans</a>, or see what's included with the <a href=\"/job-management-portal\">Job Management Portal</a> to discover how everything works together to help your business grow.",
        ResKey.BLOG1_SECTION14_PARAGRAPH5 to "If you're looking for a professional website that helps your business get found on Google, attract more customers and save you time, I'd be happy to help.",


        //BLOG2

        ResKey.BLOG2_TITLE to "10 ways sole traders can get more customers",

        ResKey.BLOG2_SECTION1_TITLE to "Introduction",

        ResKey.BLOG2_SECTION1_PARAGRAPH1 to "Winning new customers isn't always about spending more money on advertising. In many cases, it's about making it easier for people to find your business, trust your services and contact you when they need help.",
        ResKey.BLOG2_DISPLAY_TITLE to "Winning new customers isn't always about spending more money on advertising. In many cases, it's about...",

        ResKey.BLOG2_SECTION1_PARAGRAPH2 to "Whether you're a plumber, electrician, builder, gardener, cleaner, decorator or another local sole trader, there are practical steps you can take to generate more enquiries without relying entirely on recommendations. The businesses that consistently attract new customers are usually the ones that are easiest to find online and the easiest to contact.",

        ResKey.BLOG2_SECTION1_PARAGRAPH3 to "In this guide, we'll look at ten proven ways sole traders can get more customers, improve their online presence and grow their business. Most of these ideas cost very little to implement, but together they can make a significant difference over time.",


        ResKey.BLOG2_SECTION2_TITLE to "1. Optimise your Google Business Profile",

        ResKey.BLOG2_SECTION2_PARAGRAPH1 to "When someone needs a local tradesperson, their first stop is usually Google. Before they even visit a website, they'll often look at the businesses displayed on Google Maps. That's why having a complete and up-to-date Google Business Profile is one of the simplest ways to attract more enquiries.",

        ResKey.BLOG2_SECTION2_PARAGRAPH2 to "Make sure your profile includes accurate contact details, opening hours, the areas you cover, recent photographs of your work and a clear description of your services. The more complete your profile is, the more confidence potential customers will have in contacting you.",

        ResKey.BLOG2_SECTION2_PARAGRAPH3 to "Regularly uploading new photos, responding to reviews and keeping your information current also sends positive signals to Google. Combined with a professional website, your Google Business Profile becomes one of the strongest tools for helping local customers discover your business.",


        ResKey.BLOG2_SECTION3_TITLE to "2. Build a professional website",

        ResKey.BLOG2_SECTION3_PARAGRAPH1 to "Many sole traders still rely entirely on Facebook or recommendations. While both are valuable, neither gives you complete control over your online presence. A professional website allows potential customers to learn about your business, view your previous work and contact you whenever it's convenient for them.",

        ResKey.BLOG2_SECTION3_PARAGRAPH2 to "Your website should clearly explain what services you offer, where you work and why customers should choose you. It should also load quickly, work perfectly on mobile phones and make it easy for visitors to request a quote or call you directly.",

        ResKey.BLOG2_SECTION3_PARAGRAPH3 to "A well-designed website also supports your Google rankings. Every service page creates another opportunity for your business to appear when someone searches for the services you provide in your local area. Unlike social media posts that disappear over time, your website continues working for your business every day.",



        ResKey.BLOG2_SECTION4_TITLE to "3. Ask every happy customer for a review",

        ResKey.BLOG2_SECTION4_PARAGRAPH1 to "People trust other customers more than they trust advertising. Positive reviews help potential customers feel confident that they'll receive a reliable service, especially when they're comparing several businesses.",

        ResKey.BLOG2_SECTION4_PARAGRAPH2 to "Instead of waiting for customers to leave a review, make it part of your process. Once you've completed a job and the customer is happy, politely ask if they'd be willing to leave a quick review on Google or another platform where your business is listed.",

        ResKey.BLOG2_SECTION4_PARAGRAPH3 to "Over time, those reviews become one of your most valuable marketing assets. They improve trust, help your Google Business Profile stand out and often influence whether someone chooses your business over a competitor.",

        ResKey.BLOG2_SECTION4_PARAGRAPH4 to "<a href=\"/job-management-portal\">The Job Management Portal can help you request reviews after completing a job.</a>",

        ResKey.BLOG2_SECTION5_TITLE to "4. Make it easy for customers to contact you",

        ResKey.BLOG2_SECTION5_PARAGRAPH1 to "It doesn't matter how many people visit your website if they struggle to get in touch. Every extra step increases the chance that a potential customer will leave and contact somebody else instead. Your contact details should always be easy to find, whether someone is visiting from a phone or a desktop computer.",

        ResKey.BLOG2_SECTION5_PARAGRAPH2 to "Include a clear <a href=\"/contact-forms\">contact form</a>, click-to-call phone number, email address and the areas you cover. If you're often working during the day, let customers send an enquiry whenever it's convenient for them rather than expecting them to call immediately.",

        ResKey.BLOG2_SECTION5_PARAGRAPH3 to "A professionally designed website should make contacting you effortless. The easier you make it, the more enquiries you'll receive.",


        ResKey.BLOG2_SECTION6_TITLE to "5. Show examples of your previous work",

        ResKey.BLOG2_SECTION6_PARAGRAPH1 to "Customers want proof that you can deliver a high-quality job. Before choosing a tradesperson, many people look for photographs of previous work, especially for larger projects where they're investing a significant amount of money.",

        ResKey.BLOG2_SECTION6_PARAGRAPH2 to "Take photographs before, during and after each completed job whenever possible. Over time you'll build an impressive portfolio that demonstrates your experience and gives customers confidence in your workmanship.",

        ResKey.BLOG2_SECTION6_PARAGRAPH3 to "Displaying these projects on your website is far more effective than leaving them buried on social media. Your best work remains easy to find and continues helping you win new customers for years to come.",

        ResKey.BLOG2_SECTION6_PARAGRAPH4 to "Even simple before-and-after photographs can make a huge difference when someone is deciding who to contact.",


        ResKey.BLOG2_SECTION7_TITLE to "6. Improve your local SEO",

        ResKey.BLOG2_SECTION7_PARAGRAPH1 to "Most sole traders don't need to rank nationally. They only need to appear when people nearby are searching for their services. Local SEO focuses on helping your business appear for searches such as 'plumber in Leeds' or 'electrician near me'.",

        ResKey.BLOG2_SECTION7_PARAGRAPH2 to "Creating dedicated service pages, mentioning the towns and areas you cover, keeping your Google Business Profile updated and collecting genuine customer reviews all contribute towards better local rankings. Small improvements across several areas often produce better long-term results than spending heavily on advertising.",

        ResKey.BLOG2_SECTION7_PARAGRAPH3 to "SEO isn't something that happens overnight, but once your website starts ranking well it can generate enquiries month after month without paying for every click.",

        ResKey.BLOG2_SECTION7_PARAGRAPH4 to "<a href=\"/seo-services\">Find out how ongoing SEO helps local customers discover your business.</a>",


        ResKey.BLOG2_SECTION8_TITLE to "7. Stay active on Facebook and social media",

        ResKey.BLOG2_SECTION8_PARAGRAPH1 to "Social media remains an excellent way to stay visible and remind existing customers about your business. Posting photographs of completed work, sharing customer testimonials and showing what you're working on helps build familiarity and trust over time.",

        ResKey.BLOG2_SECTION8_PARAGRAPH2 to "However, social media works best when it's supporting your website rather than replacing it. Posts quickly disappear from people's feeds, whereas your website permanently showcases your services, contact details and previous projects.",

        ResKey.BLOG2_SECTION8_PARAGRAPH3 to "Whenever you share a completed project on Facebook, include a link back to your website. This encourages potential customers to learn more about your services and makes it easier for them to request a quote.",

        ResKey.BLOG2_SECTION8_PARAGRAPH4 to "Together, social media and a professional website create a much stronger marketing strategy than relying on either one alone.",

        ResKey.BLOG2_SECTION9_TITLE to "8. Reply to enquiries quickly",

        ResKey.BLOG2_SECTION9_PARAGRAPH1 to "When somebody contacts several businesses, the first person to respond often has the best chance of winning the work. Customers usually don't want to wait hours, or even days, for a reply, especially if they need urgent help. A quick response shows you're professional, organised and interested in their enquiry.",

        ResKey.BLOG2_SECTION9_PARAGRAPH2 to "You don't always need to provide a full quote immediately. Even a short message confirming you've received the enquiry and will get back to them later can leave a much better impression than complete silence.",

        ResKey.BLOG2_SECTION9_PARAGRAPH3 to "Making it easy to receive and manage enquiries means you're less likely to miss opportunities, even when you're busy on another job.",


        ResKey.BLOG2_SECTION10_TITLE to "9. Keep existing customers coming back",

        ResKey.BLOG2_SECTION10_PARAGRAPH1 to "Finding a new customer usually costs more time and effort than keeping an existing one. Once you've completed a job, stay in touch where appropriate and make it easy for previous customers to contact you again in the future.",

        ResKey.BLOG2_SECTION10_PARAGRAPH2 to "Many homeowners save the details of a reliable tradesperson and return whenever they need similar work. They may also recommend you to friends, family and neighbours, helping you generate more enquiries without spending anything on advertising.",

        ResKey.BLOG2_SECTION10_PARAGRAPH3 to "Providing great customer service, arriving on time and leaving a positive impression are often the most effective marketing tools you'll ever have. Happy customers naturally become your biggest advocates.",


        ResKey.BLOG2_SECTION11_TITLE to "10. Stay organised as your business grows",

        ResKey.BLOG2_SECTION11_PARAGRAPH1 to "Getting more customers is only half the challenge. You also need a reliable way to manage them. As your enquiries increase, relying on notebooks, text messages or memory quickly becomes difficult, and it's easy to lose track of important information.",

        ResKey.BLOG2_SECTION11_PARAGRAPH2 to "Keeping all your enquiries, customer details, notes and completed jobs organised in one place helps you work more efficiently and provide a better experience for your customers. It also reduces paperwork and saves valuable time throughout the day.",

        ResKey.BLOG2_SECTION11_PARAGRAPH3 to "If your website automatically sends new enquiries into your job management system, you can respond faster, keep everything organised and spend more time doing the work that earns you money.",

        ResKey.BLOG2_SECTION11_PARAGRAPH4 to "<a href=\"/job-management-portal\">Discover how the Job Management Portal helps sole traders manage enquiries, customers and jobs in one place.</a>",


        ResKey.BLOG2_SECTION12_TITLE to "Common mistakes that stop sole traders getting more customers",

        ResKey.BLOG2_SECTION12_PARAGRAPH1 to "Sometimes the biggest obstacle isn't a lack of marketing. It's small mistakes that make potential customers choose someone else. Avoiding these common problems can significantly improve your chances of winning more work.",

        ResKey.BLOG2_SECTION12_TABLE_HEADER1 to "Common mistake",
        ResKey.BLOG2_SECTION12_TABLE_HEADER2 to "A better approach",

        ResKey.BLOG2_SECTION12_ROW1_COL1 to "Relying only on Facebook",
        ResKey.BLOG2_SECTION12_ROW1_COL2 to "Use Facebook alongside a professional website",

        ResKey.BLOG2_SECTION12_ROW2_COL1 to "Not asking for reviews",
        ResKey.BLOG2_SECTION12_ROW2_COL2 to "Request a review after every successful job",

        ResKey.BLOG2_SECTION12_ROW3_COL1 to "Slow responses to enquiries",
        ResKey.BLOG2_SECTION12_ROW3_COL2 to "Reply as quickly as possible, even with a short message",

        ResKey.BLOG2_SECTION12_ROW4_COL1 to "No photos of previous work",
        ResKey.BLOG2_SECTION12_ROW4_COL2 to "Build a portfolio of completed projects",

        ResKey.BLOG2_SECTION12_ROW5_COL1 to "No website",
        ResKey.BLOG2_SECTION12_ROW5_COL2 to "Create a professional website that works for your business 24/7",

        ResKey.BLOG2_SECTION13_TITLE to "Which marketing methods give the best return?",

        ResKey.BLOG2_SECTION13_PARAGRAPH1 to "There are countless ways to promote a business, but not every marketing method delivers the same long-term value. The most successful sole traders usually combine several approaches rather than relying on a single source of enquiries. The table below compares some of the most common ways to attract new customers.",

        ResKey.BLOG2_SECTION13_TABLE_HEADER1 to "Marketing Method",
        ResKey.BLOG2_SECTION13_TABLE_HEADER2 to "Typical Cost",
        ResKey.BLOG2_SECTION13_TABLE_HEADER3 to "Time to See Results",
        ResKey.BLOG2_SECTION13_TABLE_HEADER4 to "Long-term Value",

        ResKey.BLOG2_SECTION13_ROW1_COL1 to "Google Business Profile",
        ResKey.BLOG2_SECTION13_ROW1_COL2 to "Free",
        ResKey.BLOG2_SECTION13_ROW1_COL3 to "Fast",
        ResKey.BLOG2_SECTION13_ROW1_COL4 to "Excellent",

        ResKey.BLOG2_SECTION13_ROW2_COL1 to "Professional Website",
        ResKey.BLOG2_SECTION13_ROW2_COL2 to "Medium",
        ResKey.BLOG2_SECTION13_ROW2_COL3 to "Medium",
        ResKey.BLOG2_SECTION13_ROW2_COL4 to "Excellent",

        ResKey.BLOG2_SECTION13_ROW3_COL1 to "Local SEO",
        ResKey.BLOG2_SECTION13_ROW3_COL2 to "Low to Medium",
        ResKey.BLOG2_SECTION13_ROW3_COL3 to "Several months",
        ResKey.BLOG2_SECTION13_ROW3_COL4 to "Excellent",

        ResKey.BLOG2_SECTION13_ROW4_COL1 to "Facebook",
        ResKey.BLOG2_SECTION13_ROW4_COL2 to "Free",
        ResKey.BLOG2_SECTION13_ROW4_COL3 to "Fast",
        ResKey.BLOG2_SECTION13_ROW4_COL4 to "Good",

        ResKey.BLOG2_SECTION13_ROW5_COL1 to "Paid Advertising",
        ResKey.BLOG2_SECTION13_ROW5_COL2 to "High",
        ResKey.BLOG2_SECTION13_ROW5_COL3 to "Immediate",
        ResKey.BLOG2_SECTION13_ROW5_COL4 to "Good while you're paying",

        ResKey.BLOG2_SECTION13_PARAGRAPH2 to "For most sole traders, the best results come from combining a well-optimised Google Business Profile, a professional website, strong customer reviews and regular updates on social media. These marketing channels support each other and continue generating enquiries long after individual posts or adverts have disappeared.",


        ResKey.BLOG2_SECTION15_TITLE to "Key takeaways",

        ResKey.BLOG2_SECTION15_PARAGRAPH1 to "If you're wondering how sole traders can get more customers, the answer isn't one big marketing trick. It's consistently doing the small things well. The businesses that attract the most enquiries are usually the easiest to find, the easiest to trust and the easiest to contact.",

        ResKey.BLOG2_SECTION15_LIST1 to "Keep your Google Business Profile complete and up to date",
        ResKey.BLOG2_SECTION15_LIST2 to "Build a professional website that showcases your business",
        ResKey.BLOG2_SECTION15_LIST3 to "Collect Google reviews after every successful job",
        ResKey.BLOG2_SECTION15_LIST4 to "Share examples of your previous work",
        ResKey.BLOG2_SECTION15_LIST5 to "Improve your local SEO so nearby customers can find you",
        ResKey.BLOG2_SECTION15_LIST6 to "Reply to enquiries as quickly as possible",
        ResKey.BLOG2_SECTION15_LIST7 to "Stay active on social media and link back to your website",
        ResKey.BLOG2_SECTION15_LIST8 to "Keep your enquiries and jobs organised as your business grows",

        ResKey.BLOG2_SECTION15_PARAGRAPH2 to "You don't need to implement everything overnight. Start with one or two improvements, build on them over time and you'll create a business that consistently generates more enquiries and wins more customers.",
        ResKey.BLOG2_SECTION16_TITLE to "Need help growing your business?",

        ResKey.BLOG2_SECTION16_PARAGRAPH1 to "Whether you're just starting out or looking to generate more enquiries, having the right online presence can make a significant difference. A professional website, combined with good local SEO and an organised way of managing enquiries, gives your business the best chance of attracting new customers consistently.",

        ResKey.BLOG2_SECTION16_PARAGRAPH2 to "If you're looking for <a href=\"/website-templates-uk\">website design for tradesmen</a> or a website built specifically for UK sole traders, I'd be happy to help. Every website is designed to perform well on Google, look great on every device and make it easy for customers to get in touch with you.",

        ResKey.BLOG2_SECTION16_PARAGRAPH3 to "You can also compare <a href=\"/website-design-pricing-uk\">website plans</a>, learn more about my <a href=\"/seo-services\">SEO services</a>, check how <a href=\"/contact-forms\">contact forms</a> work, or see how the <a href=\"/job-management-portal\">Job Management Portal</a> helps you easily manage enquiries, customers and jobs from one place.",
        ResKey.BLOG2_SECTION17_TITLE to "Frequently asked questions",

        ResKey.BLOG2_SECTION17_SUBTITLE1 to "How can a sole trader get more customers?",

        ResKey.BLOG2_SECTION17_PARAGRAPH1 to "The best way to get more customers is to make it easy for people to find and trust your business. A complete Google Business Profile, a professional website, positive customer reviews and strong local SEO all work together to generate enquiries. Consistently delivering excellent service and asking satisfied customers for reviews will also help your business grow through recommendations.",


        ResKey.BLOG2_SECTION17_SUBTITLE2 to "What's the best way to advertise as a sole trader?",

        ResKey.BLOG2_SECTION17_PARAGRAPH2 to "There's no single marketing method that works for everyone. Most successful sole traders combine several approaches, including Google Business Profile, a professional website, local SEO, customer reviews and social media. Together, these channels help attract both new and returning customers while building long-term trust.",


        ResKey.BLOG2_SECTION17_SUBTITLE3 to "Do I really need a website if I already get work through recommendations?",

        ResKey.BLOG2_SECTION17_PARAGRAPH3 to "Recommendations are one of the best ways to win new business, but many recommended customers will still search for your business online before contacting you. A professional website reassures them they've found a trusted business, showcases your previous work and makes it easy to get in touch. It also helps you attract customers who wouldn't have discovered your business through word of mouth alone.",


        ResKey.BLOG2_SECTION17_SUBTITLE4 to "Is Google Business Profile free?",

        ResKey.BLOG2_SECTION17_PARAGRAPH4 to "Yes. Google Business Profile is completely free to create and maintain. Keeping it updated with accurate information, recent photographs and genuine customer reviews can significantly improve your visibility in local search results and Google Maps.",


        ResKey.BLOG2_SECTION17_SUBTITLE5 to "How long does local SEO take to work?",

        ResKey.BLOG2_SECTION17_PARAGRAPH5 to "Local SEO is a long-term strategy rather than a quick fix. Some improvements can be seen within a few weeks, but meaningful results often take several months, depending on your location and competition. The good news is that once your website begins ranking well, it can continue generating enquiries without paying for every click.",

        //BLOG3

        ResKey.BLOG3_TITLE to "15 essential features every sole trader website should have",


        ResKey.BLOG3_SECTION1_TITLE to "Introduction",

        ResKey.BLOG3_DISPLAY_TITLE to "A professional website is one of the most valuable investments a sole trader can make.",
        ResKey.BLOG3_SECTION1_PARAGRAPH1 to "A professional website is one of the most valuable investments a sole trader can make. It works around the clock, helping potential customers discover your business, learn about your services and contact you whenever they're ready. Unlike social media, your website is completely under your control and becomes the centre of your online presence.",

        ResKey.BLOG3_SECTION1_PARAGRAPH2 to "However, not every business website is designed to generate enquiries. Some look attractive but make it difficult to find important information, while others load slowly or fail to appear in Google search results. A successful website isn't about having the fanciest design - it's about giving customers confidence and making it easy for them to choose you.",

        ResKey.BLOG3_SECTION1_PARAGRAPH3 to "In this guide, we'll look at 15 essential features every sole trader website should include. Whether you're planning your first website or replacing an outdated one, these are the features that help businesses attract more enquiries, build trust and grow over time.",


        ResKey.BLOG3_SECTION2_TITLE to "1. A clear headline that explains exactly what you do",

        ResKey.BLOG3_SECTION2_PARAGRAPH1 to "Visitors should know exactly what your business does within a few seconds of landing on your website. A clear headline immediately tells people what services you provide and helps reassure them they've come to the right place. Confusing slogans might sound clever, but they rarely answer the question customers actually have: \"Can this business help me?\"",

        ResKey.BLOG3_SECTION2_PARAGRAPH2 to "Instead of using generic phrases, explain your trade and the area you cover. For example, '{i}Electrician in Stafford providing domestic and commercial electrical services{/i}' gives visitors far more confidence than a vague slogan. It also helps search engines understand what your business does, improving your local SEO.",


        ResKey.BLOG3_SECTION3_TITLE to "2. A mobile-friendly website",

        ResKey.BLOG3_SECTION3_PARAGRAPH1 to "Most customers searching for a local tradesperson are using their phone rather than a desktop computer. They might be looking for an emergency plumber, comparing electricians or requesting a quote while travelling home from work. If your website doesn't work well on mobile devices, you'll lose enquiries before customers even read about your services.",

        ResKey.BLOG3_SECTION3_PARAGRAPH2 to "A mobile-friendly website automatically adapts to different screen sizes, making text easy to read, buttons simple to tap and navigation straightforward. Visitors shouldn't need to zoom in, scroll sideways or struggle to find your contact details. A smooth mobile experience creates confidence and makes contacting you much easier.",


        ResKey.BLOG3_SECTION4_TITLE to "3. Fast loading pages",

        ResKey.BLOG3_SECTION4_PARAGRAPH1 to "Website speed has a direct impact on both customer experience and search engine rankings. People expect pages to load almost instantly, and many will leave if they're left waiting for several seconds. Every visitor who leaves because of a slow website is a potential customer you've lost.",

        ResKey.BLOG3_SECTION4_PARAGRAPH2 to "Fast websites also perform better in Google because page speed is one of the many factors search engines consider. Optimised images, clean code and efficient hosting all contribute towards a faster browsing experience. Small improvements in speed can lead to more enquiries and higher conversion rates.",


        ResKey.BLOG3_SECTION5_TITLE to "4. Build trust with reviews, qualifications and guarantees",

        ResKey.BLOG3_SECTION5_PARAGRAPH1 to "People rarely choose the first business they find online. Instead, they compare several companies before deciding who to contact, looking for signs that a business is reliable and experienced. Your website should answer those questions immediately by showing why customers can trust you.",

        ResKey.BLOG3_SECTION5_PARAGRAPH2 to "Customer reviews are one of the strongest trust signals you can display, especially when combined with qualifications, insurance details, guarantees or memberships of recognised trade organisations. These details reassure visitors that they're dealing with a genuine professional.",


        ResKey.BLOG3_SECTION6_TITLE to "5. Make it easy for customers to contact you",

        ResKey.BLOG3_SECTION6_PARAGRAPH1 to "If somebody has decided they want your services, contacting you should take just a few seconds. Unfortunately, many business websites hide their phone number, make visitors fill in long forms, or provide only an email address for contacting them. Every extra step increases the chance that someone will leave without getting in touch.",

        ResKey.BLOG3_SECTION6_PARAGRAPH2 to "A good website should make contacting you effortless. Click-to-call buttons, simple <a href=\"/contact-forms\">contact forms</a>, email links and clear calls to action encourage visitors to take the next step. If you use WhatsApp or another messaging service for your business, that can also be included to suit the way you work.",

        ResKey.BLOG3_SECTION7_TITLE to "6. Clearly explain every service you offer",

        ResKey.BLOG3_SECTION7_PARAGRAPH1 to "Never assume visitors already know everything your business does. A vague description such as 'Property Services' tells customers very little, whereas separate sections for plumbing, bathroom installations, boiler repairs or emergency call-outs make it much easier for people to understand exactly how you can help.",

        ResKey.BLOG3_SECTION7_PARAGRAPH2 to "Clearly describing each service doesn't just help visitors - it also improves your visibility on Google. Search engines understand detailed content much better than generic descriptions, making it easier for your website to appear when someone searches for a specific service in your local area.",

        ResKey.BLOG3_SECTION8_TITLE to "7. Show the areas you cover",

        ResKey.BLOG3_SECTION8_PARAGRAPH1 to "Most customers search for businesses close to where they live or work. They often include their town or village in their search, typing phrases such as 'electrician in Stafford' or 'plumber near Cannock'. If your website doesn't clearly mention the areas you serve, you're missing valuable opportunities to appear in local search results.",

        ResKey.BLOG3_SECTION8_PARAGRAPH2 to "Creating a dedicated section that lists the towns, villages and surrounding areas you cover helps both customers and search engines understand where you work. It also reassures visitors that you regularly provide services in their location, making them more likely to contact you for a quote.",

        ResKey.BLOG3_SECTION9_TITLE to "8. Showcase your work with real photos",

        ResKey.BLOG3_SECTION9_PARAGRAPH1 to "One of the best ways to convince potential customers to choose your business is to show them the quality of your work. Real photographs give visitors confidence that you're experienced and proud of what you do. They also help your website stand out from competitors who rely on generic stock images.",

        ResKey.BLOG3_SECTION9_PARAGRAPH2 to "Before and after photos are especially effective for decorators, landscapers, builders, cleaners, kitchen fitters and many other trades. They demonstrate the transformation you've achieved and allow customers to imagine what you could do for their own property. Updating your gallery regularly with recent projects also shows that your business is active and trusted by local customers.",

        ResKey.BLOG3_SECTION10_TITLE to "9. Answer common questions with an FAQ",

        ResKey.BLOG3_SECTION10_PARAGRAPH1 to "Most customers ask the same questions before deciding to contact a business. They want to know whether you provide free quotations, which areas you cover, whether you're insured or how quickly you can complete the work. If your website answers these questions in advance, visitors are far more likely to get in touch.",

        ResKey.BLOG3_SECTION10_PARAGRAPH2 to "An FAQ section saves time for both you and your customers. It reduces the number of repetitive enquiries you receive while helping visitors find the information they need without having to phone or send an email. It also demonstrates that you understand the concerns customers typically have before hiring a tradesperson.",

        ResKey.BLOG3_SECTION10_PARAGRAPH3 to "Well-written FAQs can also improve your website's visibility on Google because they naturally include the questions people search for online. Combined with clear service pages and local SEO, they become another valuable part of your website.",


        ResKey.BLOG3_SECTION11_TITLE to "10. Optimise your website for local SEO",

        ResKey.BLOG3_SECTION11_PARAGRAPH1 to "A great-looking website won't generate many enquiries if nobody can find it. Local SEO helps your website appear when people search for services such as 'plumber in Stafford' or 'electrician near me'. By optimising your content for the locations and services you provide, you increase your chances of attracting customers who are ready to hire someone.",

        ResKey.BLOG3_SECTION11_PARAGRAPH2 to "Good local SEO involves much more than adding a few keywords. Fast loading pages, clear headings, properly structured content, relevant page titles and links between related pages all help search engines understand your website. Combined with a complete Google Business Profile, these improvements can significantly increase your visibility.",

        ResKey.BLOG3_SECTION11_PARAGRAPH3 to "Every website I build includes SEO foundations from day one rather than treating optimisation as an afterthought. If you'd like to learn more, take a look at our <a href=\"/seo-services\">SEO services</a> and discover how I help sole traders improve their visibility online.",

        ResKey.BLOG3_SECTION11_TABLE_HEADER1 to "Without Local SEO",
        ResKey.BLOG3_SECTION11_TABLE_HEADER2 to "With Local SEO",

        ResKey.BLOG3_SECTION11_ROW1_COL1 to "Harder to appear in Google searches",
        ResKey.BLOG3_SECTION11_ROW1_COL2 to "Better visibility for local searches",

        ResKey.BLOG3_SECTION11_ROW2_COL1 to "Relies mostly on recommendations",
        ResKey.BLOG3_SECTION11_ROW2_COL2 to "Brings in customers searching online",

        ResKey.BLOG3_SECTION11_ROW3_COL1 to "Fewer enquiries from new customers",
        ResKey.BLOG3_SECTION11_ROW3_COL2 to "More opportunities to generate enquiries",

        ResKey.BLOG3_SECTION11_ROW4_COL1 to "Service areas aren't clearly understood",
        ResKey.BLOG3_SECTION11_ROW4_COL2 to "Google understands where you work",

        ResKey.BLOG3_SECTION11_ROW5_COL1 to "Pages may be difficult for search engines to understand",
        ResKey.BLOG3_SECTION11_ROW5_COL2 to "Well-structured pages improve indexing",

        ResKey.BLOG3_SECTION11_ROW6_COL1 to "Limited long-term growth",
        ResKey.BLOG3_SECTION11_ROW6_COL2 to "Builds stronger visibility over time",

        ResKey.BLOG3_SECTION12_TITLE to "11. Use clear calls to action",

        ResKey.BLOG3_SECTION12_PARAGRAPH1 to "After reading your website, visitors should never be left wondering what to do next. Every important page should encourage them to take a simple action, whether that's requesting a quote, calling you, completing a contact form or sending an email. Clear calls to action help guide customers through your website and increase the number of enquiries you receive.",

        ResKey.BLOG3_SECTION12_PARAGRAPH2 to "Effective calls to action are visible without being intrusive. Rather than hiding your contact details at the bottom of the page, place them throughout your website where visitors naturally expect to find them. Small improvements like these often have a surprisingly positive impact on conversion rates.",

        ResKey.BLOG3_SECTION13_TITLE to "12. Keep your website secure and up to date",

        ResKey.BLOG3_SECTION13_PARAGRAPH1 to "A professional website isn't something you build once and forget about. Domains need renewing, security certificates must remain valid and software should be kept up to date to ensure everything continues working properly. Regular maintenance helps prevent unexpected problems and keeps your website performing at its best.",

        ResKey.BLOG3_SECTION13_PARAGRAPH2 to "Without ongoing maintenance, websites can gradually become slower, outdated or vulnerable to security issues. Broken contact forms, expired certificates or missing updates can all create a poor impression and even cost you potential customers. Looking after your website is just as important as maintaining any other part of your business.",


        ResKey.BLOG3_SECTION14_TITLE to "13. Make sure your website can grow with your business",

        ResKey.BLOG3_SECTION14_PARAGRAPH1 to "Your business today may look very different in a year's time. You might expand into new areas, introduce additional services, employ staff or build an impressive portfolio of completed projects. Your website should be able to grow alongside your business rather than limiting what you can achieve.",

        ResKey.BLOG3_SECTION14_PARAGRAPH2 to "Adding new pages, customer reviews, before and after galleries or seasonal services should be straightforward. A flexible website allows you to keep your content up to date, helping both your customers and Google see that your business is active and continually improving.",

        ResKey.BLOG3_SECTION14_PARAGRAPH3 to "Every website I build is designed with future growth in mind. Whether you need extra pages, new functionality or integration with the <a href=\"/job-management-portal\">Job Management Portal</a>, your website can evolve as your business develops.",

        ResKey.BLOG3_SECTION18_TITLE to "14. Clear pricing or an easy way to request a quote",

        ResKey.BLOG3_SECTION18_PARAGRAPH1 to "One of the biggest reasons visitors leave a website is because they don't know what to do next. While you don't always need to display exact prices, giving customers an idea of your pricing or making it simple to request a free quote removes uncertainty and encourages them to get in touch.",

        ResKey.BLOG3_SECTION18_PARAGRAPH2 to "Some trades prefer to show 'Prices from…', while others simply offer free, no-obligation quotations. Either approach works well, as long as visitors understand what to expect and can contact you without searching for your phone number or email address.",

        ResKey.BLOG3_SECTION19_TITLE to "15. Introduce yourself and your business",

        ResKey.BLOG3_SECTION19_PARAGRAPH1 to "People don't just hire a business - they hire the person behind it. A dedicated 'About Me' page or section helps potential customers get to know who they'll be inviting into their home. Sharing your experience, qualifications and the story behind your business makes your website feel more personal and trustworthy.",

        ResKey.BLOG3_SECTION19_PARAGRAPH2 to "Include a friendly photo of yourself, explain how long you've been in business and mention what you enjoy about your work. You don't need to write your life story, but a genuine introduction can help visitors feel more comfortable contacting you. Customers are much more likely to trust a real person than a business that feels anonymous.",


        ResKey.BLOG3_SECTION15_TITLE to "Ready for a website that works as hard as you do?",

        ResKey.BLOG3_SECTION15_PARAGRAPH1 to "A successful sole trader website is much more than an online brochure. It should help customers find your business, build confidence in your services and make it simple for people to get in touch. Every feature in this guide plays a part in turning visitors into enquiries and enquiries into paying customers.",

        ResKey.BLOG3_SECTION15_PARAGRAPH2 to "When these features work together - clear messaging, mobile-friendly design, local SEO, customer reviews, before and after galleries, fast loading pages and strong calls to action - you create a website that supports your business every day, even while you're busy on the job.",

        ResKey.BLOG3_SECTION15_PARAGRAPH3 to "All of my <a href=\"/website-templates-uk\">website templates</a> include these essential features as standard and are designed specifically for UK sole traders and small businesses. Every website is built with performance, usability and local SEO in mind, helping you create a professional online presence from day one.",

        ResKey.BLOG3_SECTION15_PARAGRAPH4 to "If you're looking for a completely bespoke solution, I also create custom website designs tailored to your business. You can compare my <a href=\"/website-design-pricing-uk\">website packages and maintenance plans</a> to find the option that suits you best.",

        ResKey.BLOG3_SECTION15_PARAGRAPH5 to "Whether you're launching your first website or replacing an outdated one, I'd be delighted to help you build a website that looks professional, performs well on Google and helps your business win more customers. <a href=\"/#contact\">Get in touch</a> to discuss your project.",


        ResKey.BLOG3_SECTION16_TITLE to "How I can help",

        ResKey.BLOG3_SECTION16_TABLE_HEADER1 to "Feature",
        ResKey.BLOG3_SECTION16_TABLE_HEADER2 to "How I can help",

        ResKey.BLOG3_SECTION16_ROW1_COL1 to "Clear headline",
        ResKey.BLOG3_SECTION16_ROW1_COL2 to "Every <a href=\"/website-templates-uk\">website template</a> includes customer-focused headings that clearly explain what you do.",

        ResKey.BLOG3_SECTION16_ROW2_COL1 to "Mobile-friendly design",
        ResKey.BLOG3_SECTION16_ROW2_COL2 to "Every website is fully responsive and designed to look great on phones, tablets and desktops.",

        ResKey.BLOG3_SECTION16_ROW3_COL1 to "Fast loading pages",
        ResKey.BLOG3_SECTION16_ROW3_COL2 to "I build lightweight websites with performance in mind to provide a fast experience for visitors and Google.",

        ResKey.BLOG3_SECTION16_ROW4_COL1 to "Trust signals",
        ResKey.BLOG3_SECTION16_ROW4_COL2 to "Dedicated sections for customer reviews, qualifications, guarantees and other trust-building content are included.",

        ResKey.BLOG3_SECTION16_ROW5_COL1 to "Easy contact options",
        ResKey.BLOG3_SECTION16_ROW5_COL2 to "Professional <a href=\"/contact-forms\">contact forms</a>, click-to-call buttons and simple enquiry options help you win more customers.",

        ResKey.BLOG3_SECTION16_ROW6_COL1 to "Service pages",
        ResKey.BLOG3_SECTION16_ROW6_COL2 to "I organise your services so both customers and Google can easily understand what you offer.",

        ResKey.BLOG3_SECTION16_ROW7_COL1 to "Local SEO",
        ResKey.BLOG3_SECTION16_ROW7_COL2 to "Every website includes strong SEO foundations, and you can also learn more about my <a href=\"/seo-services\">SEO services</a>.",

        ResKey.BLOG3_SECTION16_ROW8_COL1 to "Before & after gallery",
        ResKey.BLOG3_SECTION16_ROW8_COL2 to "Showcase your best work with attractive image galleries that are easy to update.",

        ResKey.BLOG3_SECTION16_ROW9_COL1 to "FAQ section",
        ResKey.BLOG3_SECTION16_ROW9_COL2 to "I'll work with you to create an FAQ tailored to your business to answer common customer questions.",

        ResKey.BLOG3_SECTION16_ROW10_COL1 to "Easy quote requests",
        ResKey.BLOG3_SECTION16_ROW10_COL2 to "Every page is designed to encourage visitors to request a quote or get in touch.",

        ResKey.BLOG3_SECTION16_ROW11_COL1 to "Website maintenance",
        ResKey.BLOG3_SECTION16_ROW11_COL2 to "Choose one of my <a href=\"/website-design-pricing-uk\">maintenance plans</a> and I'll take care of updates, security and backups.",

        ResKey.BLOG3_SECTION16_ROW12_COL1 to "Business management",
        ResKey.BLOG3_SECTION16_ROW12_COL2 to "Connect your website with the <a href=\"/job-management-portal\">Job Management Portal</a> to organise enquiries, customers and jobs.",

        ResKey.BLOG3_SECTION16_ROW13_COL1 to "Custom website",
        ResKey.BLOG3_SECTION16_ROW13_COL2 to "Need something unique? I also create bespoke websites for UK trades and sole traders.",

        ResKey.BLOG3_SECTION16_ROW14_COL1 to "About Me section",
        ResKey.BLOG3_SECTION16_ROW14_COL2 to "I'll create a professional About Me section that introduces you, highlights your experience and helps customers feel confident choosing you over your competitors.",


        ResKey.BLOG3_SECTION17_TITLE to "Frequently asked questions",

        ResKey.BLOG3_SECTION17_SUBTITLE1 to "Do I need every feature from day one?",
        ResKey.BLOG3_SECTION17_PARAGRAPH1 to "Not necessarily. The most important thing is to launch a professional website with solid foundations. Additional sections and features can always be added as your business grows.",

        ResKey.BLOG3_SECTION17_SUBTITLE2 to "Will these features help my website rank on Google?",
        ResKey.BLOG3_SECTION17_PARAGRAPH2 to "Many of these features contribute towards better SEO and a better user experience, but no one can guarantee first place on Google. A fast, well-structured website combined with good content and a complete Google Business Profile gives your business the strongest possible foundation.",

        ResKey.BLOG3_SECTION17_SUBTITLE3 to "How often should I update my website?",
        ResKey.BLOG3_SECTION17_PARAGRAPH3 to "It's a good idea to add new projects, customer reviews and updated information whenever your business changes. Keeping your website fresh shows customers that your business is active and gives search engines new content to index.",

        ResKey.BLOG3_SECTION17_SUBTITLE4 to "Will you look after my website?",
        ResKey.BLOG3_SECTION17_PARAGRAPH4 to "Yes. When I build your website, I'll look after it for you through one of my ongoing <a href=\"/website-design-pricing-uk\">maintenance plans</a>. I'll take care of updates, content and photo changes, backups, security monitoring and technical improvements, keeping your website running smoothly while you concentrate on running your business.",

        //BLOG4

        ResKey.BLOG4_TITLE to "How much does a website cost for a sole trader in the UK?",

        ResKey.BLOG4_DISPLAY_TITLE to "From free website builders to £5,000 agency projects, website prices vary hugely. Here's what you actually get for your money.",

        ResKey.BLOG4_SECTION1_TITLE to "Introduction",

        ResKey.BLOG4_SECTION1_PARAGRAPH1 to "\"How much does a website cost?\" is one of the first questions every sole trader asks, and it's a hard one to answer. Search online and you'll find free website builders, freelancers charging a few hundred pounds and agencies quoting several thousand. It's no surprise that many tradespeople put off getting a website because they simply don't know what a fair price looks like.",

        ResKey.BLOG4_SECTION1_PARAGRAPH2 to "The truth is that the price on the label is only part of the story. Some options look cheap but cost you hours of your own time, monthly subscriptions and lost enquiries. Others are excellent quality but priced for much larger businesses than a one-person trade. What matters is the total cost over time and whether the website actually brings in work.",

        ResKey.BLOG4_SECTION1_PARAGRAPH3 to "In this guide, I'll compare the most common ways a UK sole trader can get a website, what each one really costs, the hidden costs to watch out for and how to decide which option gives you the best value for your business.",

        ResKey.BLOG4_SECTION2_TITLE to "The quick answer",

        ResKey.BLOG4_SECTION2_PARAGRAPH1 to "For most UK sole traders, a professional website should cost somewhere between a few hundred pounds and £1,500 to build, plus a monthly fee to keep it online, secure and up to date. Here's a rough guide to what each option typically costs:",

        ResKey.BLOG4_SECTION2_TABLE_HEADER1 to "Option",
        ResKey.BLOG4_SECTION2_TABLE_HEADER2 to "Typical cost",
        ResKey.BLOG4_SECTION2_TABLE_HEADER3 to "The catch",

        ResKey.BLOG4_SECTION2_ROW1_COL1 to "DIY website builder",
        ResKey.BLOG4_SECTION2_ROW1_COL2 to "£0 to start, then around £10-£35 a month",
        ResKey.BLOG4_SECTION2_ROW1_COL3 to "You build, write and maintain everything yourself",

        ResKey.BLOG4_SECTION2_ROW2_COL1 to "WordPress, built yourself",
        ResKey.BLOG4_SECTION2_ROW2_COL2 to "£50-£200 for themes and plugins, plus £5-£25 a month hosting",
        ResKey.BLOG4_SECTION2_ROW2_COL3 to "Steep learning curve and ongoing security updates",

        ResKey.BLOG4_SECTION2_ROW3_COL1 to "Freelance web designer",
        ResKey.BLOG4_SECTION2_ROW3_COL2 to "£500-£2,000 upfront, plus hosting and changes",
        ResKey.BLOG4_SECTION2_ROW3_COL3 to "Quality and aftercare vary a lot",

        ResKey.BLOG4_SECTION2_ROW4_COL1 to "Web design agency",
        ResKey.BLOG4_SECTION2_ROW4_COL2 to "£2,000-£5,000+ upfront, plus £50-£150 a month",
        ResKey.BLOG4_SECTION2_ROW4_COL3 to "Usually more than a sole trader needs",

        ResKey.BLOG4_SECTION2_ROW5_COL1 to "Social media page only",
        ResKey.BLOG4_SECTION2_ROW5_COL2 to "Free",
        ResKey.BLOG4_SECTION2_ROW5_COL3 to "Harder to find on Google and you don't control it",

        ResKey.BLOG4_SECTION2_ROW6_COL1 to "Anjuros Development",
        ResKey.BLOG4_SECTION2_ROW6_COL2 to "£99 one-off (bespoke from £149), plus care plans from £9.99 a month",
        ResKey.BLOG4_SECTION2_ROW6_COL3 to "No catch - nothing to pay upfront, and you only pay once you're happy",

        ResKey.BLOG4_SECTION2_PARAGRAPH2 to "Prices are typical UK figures and will vary, but they show the pattern clearly: the cheapest options cost you time, and the most expensive ones cost you money you don't need to spend. Below, I look at each option in more detail.",

        ResKey.BLOG4_SECTION3_TITLE to "1. DIY website builders",

        ResKey.BLOG4_SECTION3_PARAGRAPH1 to "Website builders such as Wix, Squarespace and GoDaddy promise a professional website in an afternoon. You pick a template, drag in your text and photos, and publish. Many advertise a free plan, which makes them very tempting when you're just starting out.",

        ResKey.BLOG4_SECTION3_PARAGRAPH2 to "In practice, free plans show the builder's adverts and use a web address like {i}yourname.wixsite.com{/i}, which doesn't look professional to customers. To use your own domain, remove the adverts and add a proper contact form, you'll usually need a paid plan of around £10-£35 a month - often more once you add extras such as booking tools or extra storage. Over a few years, that adds up to more than many professionally built websites.",

        ResKey.BLOG4_SECTION3_PARAGRAPH3 to "The biggest cost, though, is your time. Writing the content, choosing the right images, setting up local SEO and making everything work well on phones can take days, and the result often looks like exactly what it is: a template filled in by someone who'd rather be on the tools. Every evening spent fiddling with your website is an evening you're not quoting, working or resting.",

        ResKey.BLOG4_SECTION4_TITLE to "2. Building it yourself with WordPress",

        ResKey.BLOG4_SECTION4_PARAGRAPH1 to "WordPress powers a huge share of the web and gives you far more flexibility than a simple website builder. The software itself is free, but you'll need to pay for hosting, a domain name and usually a premium theme and a handful of plugins for contact forms, SEO and security.",

        ResKey.BLOG4_SECTION4_PARAGRAPH2 to "The real challenge is that you become your own web developer. WordPress sites need regular updates to stay secure, plugins can clash with each other, and a slow or hacked website can quietly cost you enquiries for weeks before you notice. It's a great option if you enjoy the technical side, but most sole traders find it takes far more time than they expected.",

        ResKey.BLOG4_SECTION5_TITLE to "3. Hiring a freelance web designer",

        ResKey.BLOG4_SECTION5_PARAGRAPH1 to "A good freelancer can build you a professional website for somewhere between £500 and £2,000, depending on the number of pages and features. You get a real person to talk to and a website designed around your business, which is a big step up from a DIY template.",

        ResKey.BLOG4_SECTION5_PARAGRAPH2 to "The quality and aftercare, however, vary enormously. Some freelancers hand over the website and move on, leaving you to sort out hosting, updates and security yourself. Others are hard to reach when you need a quick change, or don't tell you upfront what changes will cost. Before you choose, always ask what happens after launch: who looks after the website, how much changes cost and whether SEO and mobile design are included.",

        ResKey.BLOG4_SECTION6_TITLE to "4. Going to a web design agency",

        ResKey.BLOG4_SECTION6_PARAGRAPH1 to "Agencies have teams of designers, developers and marketers, and they produce excellent work. That expertise comes at a price, though: projects typically start from around £2,000 and can easily reach £5,000 or more, often with monthly retainers of £50-£150 for hosting, support and updates.",

        ResKey.BLOG4_SECTION6_PARAGRAPH2 to "For a larger company with complex requirements, that can be money well spent. For a plumber, electrician, cleaner or decorator who needs a clear, fast website that brings in local enquiries, it's usually far more than necessary. You end up paying for meetings, project managers and agency overheads rather than features that win you more work.",

        ResKey.BLOG4_SECTION7_TITLE to "5. Relying on social media and directory sites",

        ResKey.BLOG4_SECTION7_PARAGRAPH1 to "A Facebook page or Instagram account costs nothing and can be a great way to share recent work. Many tradespeople also join directory and lead-generation websites, which charge a monthly membership or a fee for every lead you receive.",

        ResKey.BLOG4_SECTION7_PARAGRAPH2 to "The problem is that you're building your business on someone else's platform. Social media posts rarely appear when customers search Google for a local trade, algorithms decide who sees your content, and directory sites place your competitors right next to you. Membership and lead fees can also cost far more over a year than your own website would. These platforms work best alongside a website, not instead of one. I explain this in more detail in <a href=\"/blog/why-every-sole-trader-needs-a-website\">why every sole trader needs a website</a>.",

        ResKey.BLOG4_SECTION8_TITLE to "The hidden costs of a website",

        ResKey.BLOG4_SECTION8_PARAGRAPH1 to "Whichever option you choose, the build price is only the beginning. When you compare quotes, make sure you know who pays for each of these:",

        ResKey.BLOG4_SECTION8_POINT1 to "{b}Domain name{/b} - your web address, usually £10-£20 a year, which needs renewing on time or your website disappears.",
        ResKey.BLOG4_SECTION8_POINT2 to "{b}Hosting{/b} - the server that keeps your website online, from a few pounds to £25 or more a month.",
        ResKey.BLOG4_SECTION8_POINT3 to "{b}SSL certificate{/b} - the padlock in the browser that shows your website is secure. Without it, browsers warn visitors your site is 'Not secure'.",
        ResKey.BLOG4_SECTION8_POINT4 to "{b}Updates and changes{/b} - new prices, photos, reviews or services. Some designers charge £30-£60 an hour for even small edits.",
        ResKey.BLOG4_SECTION8_POINT5 to "{b}Security and backups{/b} - keeping software up to date and having a copy of your website if anything goes wrong.",
        ResKey.BLOG4_SECTION8_POINT6 to "{b}Your own time{/b} - the hours you spend building, fixing or updating a website are hours you could spend earning.",

        ResKey.BLOG4_SECTION8_PARAGRAPH2 to "A website that looks cheap upfront but needs constant attention, or one that nobody can find on Google, often turns out to be the most expensive option of all. The cost of missed enquiries rarely appears on any invoice, but it's very real.",

        ResKey.BLOG4_SECTION9_TITLE to "What should a sole trader actually pay?",

        ResKey.BLOG4_SECTION9_PARAGRAPH1 to "Rather than asking what the cheapest website is, it helps to ask what a website is worth to your business. For most trades, a single new job can be worth anywhere from £100 to several thousand pounds. If your website brings in just one or two extra customers a year, it has already paid for itself - and a good website should bring in far more than that.",

        ResKey.BLOG4_SECTION9_PARAGRAPH2 to "That doesn't mean you need to spend thousands. A sole trader website doesn't need dozens of pages or complicated features. It needs to look professional, work perfectly on phones, load quickly, explain your services and the areas you cover, show your reviews and make it easy for customers to get in touch. You can read the full list in my guide to <a href=\"/blog/15-essential-features-every-sole-trader-website-should-have\">15 essential features every sole trader website should have</a>.",

        ResKey.BLOG4_SECTION9_PARAGRAPH3 to "The best value option is one that gives you all of those essentials, built properly with local SEO in mind, at a price that makes sense for a one-person business - and with someone looking after it so you don't have to.",

        ResKey.BLOG4_SECTION10_TITLE to "How my pricing compares",

        ResKey.BLOG4_SECTION10_PARAGRAPH1 to "I created Anjuros Development specifically for UK sole traders and small trades businesses, so my pricing is designed around what you actually need. Here's how it compares with the typical costs elsewhere:",

        ResKey.BLOG4_SECTION10_TABLE_HEADER1 to "What you need",
        ResKey.BLOG4_SECTION10_TABLE_HEADER2 to "Typical cost elsewhere",
        ResKey.BLOG4_SECTION10_TABLE_HEADER3 to "With me",

        ResKey.BLOG4_SECTION10_ROW1_COL1 to "Website design and build",
        ResKey.BLOG4_SECTION10_ROW1_COL2 to "£500-£5,000",
        ResKey.BLOG4_SECTION10_ROW1_COL3 to "£99 for a customised design, or from £149 for a fully bespoke website",

        ResKey.BLOG4_SECTION10_ROW2_COL1 to "Payment upfront",
        ResKey.BLOG4_SECTION10_ROW2_COL2 to "Often 50% deposit or more",
        ResKey.BLOG4_SECTION10_ROW2_COL3 to "Nothing - you pay once you're happy with your finished website",

        ResKey.BLOG4_SECTION10_ROW3_COL1 to "Domain, hosting and SSL",
        ResKey.BLOG4_SECTION10_ROW3_COL2 to "Paid separately, often to different companies",
        ResKey.BLOG4_SECTION10_ROW3_COL3 to "All included in every care plan, from £9.99 a month",

        ResKey.BLOG4_SECTION10_ROW4_COL1 to "Security, backups and updates",
        ResKey.BLOG4_SECTION10_ROW4_COL2 to "Your job, or an extra monthly fee",
        ResKey.BLOG4_SECTION10_ROW4_COL3 to "Included as standard - I look after it for you",

        ResKey.BLOG4_SECTION10_ROW5_COL1 to "Content changes",
        ResKey.BLOG4_SECTION10_ROW5_COL2 to "£30-£60 an hour",
        ResKey.BLOG4_SECTION10_ROW5_COL3 to "From £10 per update, or up to 3 a month included with Care Plus",

        ResKey.BLOG4_SECTION10_ROW6_COL1 to "Mobile design and local SEO",
        ResKey.BLOG4_SECTION10_ROW6_COL2 to "Sometimes extra",
        ResKey.BLOG4_SECTION10_ROW6_COL3 to "Built into every website from day one",

        ResKey.BLOG4_SECTION10_ROW7_COL1 to "Managing enquiries and jobs",
        ResKey.BLOG4_SECTION10_ROW7_COL2 to "Separate software subscription",
        ResKey.BLOG4_SECTION10_ROW7_COL3 to "<a href=\"/job-management-portal\">Job Management Portal</a> included with Full Service, free for your first 2 months",

        ResKey.BLOG4_SECTION10_PARAGRAPH2 to "Put simply, a customised website with my Basic Care plan costs less than £200 for your whole first year: £99 for the website, two months of Full Service free, then £9.99 a month. That's less than many website builders charge, without you having to build or maintain anything yourself. You can see every option on my <a href=\"/website-design-pricing-uk\">website design pricing</a> page.",

        ResKey.BLOG4_SECTION11_TITLE to "A professional website without the agency price tag",

        ResKey.BLOG4_SECTION11_PARAGRAPH1 to "There's no single right price for a website, but there is a right choice for most sole traders. DIY builders cost you time, agencies cost you money you don't need to spend, and social media alone leaves you invisible on Google. What most tradespeople need is a professional, fast, mobile-friendly website built for local customers, at a fair price, with someone looking after it.",

        ResKey.BLOG4_SECTION11_PARAGRAPH2 to "That's exactly what I offer. You can choose one of my <a href=\"/website-templates-uk\">website designs</a> and I'll customise it with your content, images, colours and branding for £99, or I can design a completely bespoke website from £149. Every website includes mobile-friendly design, a contact form tailored to your business and strong SEO foundations as standard.",

        ResKey.BLOG4_SECTION11_PARAGRAPH3 to "There's no risk to you: you don't pay anything upfront, you only pay the build fee once you're happy with your website, and your first two months of Full Service are free. After that, you can choose the care plan that suits you, and upgrade, downgrade or cancel at any time.",

        ResKey.BLOG4_SECTION11_PARAGRAPH4 to "If you'd like a website that looks professional, helps customers find you and doesn't cost a fortune, I'd love to help. <a href=\"/#contact\">Get in touch</a> and tell me about your business.",

        ResKey.BLOG4_SECTION12_TITLE to "Frequently asked questions",

        ResKey.BLOG4_SECTION12_SUBTITLE1 to "Why is your website so much cheaper than an agency?",
        ResKey.BLOG4_SECTION12_PARAGRAPH1 to "I work only with sole traders and small trades businesses, so I've built a set of proven website designs around what those businesses need. Customising one of these is much faster than starting from a blank page, and as a small business myself I don't have agency overheads to cover. You get the same essentials - mobile design, fast pages and SEO foundations - without paying for things you don't need.",

        ResKey.BLOG4_SECTION12_SUBTITLE2 to "Do I have to pay anything upfront?",
        ResKey.BLOG4_SECTION12_PARAGRAPH2 to "No. I'll build your website first, and you only pay the one-off build fee once you're happy with the finished result. Your first two months of Full Service are also free.",

        ResKey.BLOG4_SECTION12_SUBTITLE3 to "Are there any hidden costs?",
        ResKey.BLOG4_SECTION12_PARAGRAPH3 to "No. Your domain renewal, hosting, SSL certificate, backups, security monitoring and software updates are all included in every care plan. The only extras are content updates on the Basic Care plan, which start from £10 and are listed clearly on my <a href=\"/website-design-pricing-uk\">pricing page</a>. On Care Plus and Full Service, updates are free of charge - up to 3 or 5 a month, depending on your plan.",

        ResKey.BLOG4_SECTION12_SUBTITLE4 to "Is a cheaper website worse quality?",
        ResKey.BLOG4_SECTION12_PARAGRAPH4 to "Not necessarily. A website's quality depends on how well it's built, how fast it loads and how easy it makes it for customers to contact you - not on how much it cost. Many expensive websites are slow and hard to use on phones, while a well-built website for a sole trader can perform brilliantly on Google.",

        ResKey.BLOG4_SECTION12_SUBTITLE5 to "Can I cancel my care plan?",
        ResKey.BLOG4_SECTION12_PARAGRAPH5 to "Yes. You can pay monthly or annually, and upgrade, downgrade or cancel your plan at any time. A care plan is what keeps your website online, so cancelling it means your website will no longer be hosted and maintained.",

        ),
)


data class LanguageContext(
    val lang: Language,
    val setLang: (Language) -> Unit
)

// Create the CompositionLocal. It needs a default value.
val LocalLanguage = compositionLocalOf {
    LanguageContext(
        lang = Language.EN,
        setLang = {},
    )
}

val LocalUiMode = compositionLocalOf { UiMode.NORMAL }


@Composable
fun LocalText(key: ResKeyType?): String {
    val map = getTextResources(key)
    return map.mapped(key)
}


@Composable
fun getTextResources(key: ResKeyType?): Map<out ResKeyType, String>? {
    when (key) {
        is com.anjuros.website.templates.template1.util.ResKey -> {
            return com.anjuros.website.templates.template1.util.TextResources[LocalLanguage.current.lang]
        }

        is com.anjuros.website.templates.template2.util.ResKey -> {
            return com.anjuros.website.templates.template2.util.TextResources[LocalLanguage.current.lang]
        }


        is com.anjuros.website.templates.template4.util.ResKey -> {
            return com.anjuros.website.templates.template4.util.TextResources[LocalLanguage.current.lang]
        }

        is com.anjuros.website.templates.template5.util.ResKey -> {
            return com.anjuros.website.templates.template5.util.TextResources[LocalLanguage.current.lang]
        }

        is com.anjuros.website.templates.template6.util.ResKey -> {
            return com.anjuros.website.templates.template6.util.TextResources[LocalLanguage.current.lang]
        }


        is com.anjuros.website.templates.template8.util.ResKey -> {
            return com.anjuros.website.templates.template8.util.TextResources[LocalLanguage.current.lang]
        }

        is com.anjuros.website.templates.template9.util.ResKey -> {
            return com.anjuros.website.templates.template9.util.TextResources[LocalLanguage.current.lang]
        }

        is com.anjuros.website.templates.template10.util.ResKey -> {
            return com.anjuros.website.templates.template10.util.TextResources[LocalLanguage.current.lang]
        }

        is com.anjuros.website.redesign.util.RdText -> {
            return com.anjuros.website.redesign.util.RdTextResources[LocalLanguage.current.lang]
        }

        else -> return TextResources[LocalLanguage.current.lang]
    }
}


@Composable
fun <K : ResKeyType> Map<K, String>?.mapped(key: ResKeyType?): String {

    if (LocalUiMode.current == UiMode.PLACEHOLDER) {

        val keyName = key?.keyName ?: return this?.get(key).orEmpty()

        val match = placeholderTextMap.entries.firstOrNull { it.key.matches(keyName) }
        if (match != null) return TextResources[LocalLanguage.current.lang]?.get(match.value)
            .orEmpty()
    }

    return this?.get(key).orEmpty()
}
